export default {
    common: {
        actions: 'Actions',
        add: 'Add',
        edit: 'Edit',
        delete: 'Delete',
        more: 'More',
        search: 'Search',
        reset: 'Reset',
        export: 'Export',
        submit: 'Confirm',
        confirm: 'Confirm',
        reset: 'Reset',
        to: 'to',
        cancel: 'Cancel',
        info: 'Info',
        enable: 'Enable',
        disable: 'Disable',
        expand: 'Expand/Collapse',
        close: 'Close',
        startDate: 'Start Date',
        endDate: 'End Date',
        to: 'to',
        success: 'Success',
        warning: 'Warning',
        error: 'Error',
        yes: 'Yes',
        no: 'No',
        noData: 'No Data',
        back: 'Back',
        status: 'Status',
        createTime: 'Created',
        updateTime: 'Updated',
        normal: 'Normal',
        addSuccess: 'Added successfully',
        editSuccess: 'Updated successfully',
        deleteSuccess: 'Deleted successfully',
        selectedCount: '{n} selected',
        clearSelection: 'Clear selection',
        collapseAll: 'Collapse all',
        expandAll: 'Expand all',
        keyword: 'Keyword',
        refresh: 'Refresh'
    },
    template: {
        private: {
            searchPlaceholder: 'Please enter template name',
            empty: 'No templates found'
        },
        public: {
            searchPlaceholder: 'Enter template keywords',
            categoryAll: 'All Templates',
            defaultCategory: 'Public Template',
            use: 'Use',
            detail: 'Details',
            empty: 'No templates',
            total: 'Total {count}',
            previewMissingId: 'Template is missing project ID. Cannot preview.',
            copyMissingId: 'Template is missing project ID. Cannot copy.',
            copyConfirmMessage: 'Copy a new project from this template and go to Design. Continue?',
            sameAsSource: 'Same as source project',
            copyNoResponse: 'Copy failed: no response',
            copyFailed: 'Copy failed',
            copySuccessNoId: 'Copied, but new project ID not found',
            copySuccessJump: 'Copied successfully, redirecting',
            copyFailRetry: 'Copy failed, please try again later'
        },
        preview: {
            headerTitle: 'Survey Questions Preview',
            titleDefault: 'Survey Preview',
            subtitleDefault: 'Question preview (options hidden)',
            defaultEstimateTime: '5-10 minutes',
            questionCount: 'Total {count} questions',
            estimatedTime: 'Estimated time: {time}',
            noOptionsNote: 'Preview questions only; options hidden',
            sectionTitle: 'Question List',
            untitledQuestion: 'Untitled Question',
            empty: 'No questions',
            loadFail: 'Failed to load preview',
            type: {
                TEXT: 'Short Answer',
                TEXTAREA: 'Paragraph',
                SINGLE: 'Single Choice',
                MULTIPLE: 'Multiple Choice',
                OPEN: 'Open Question',
                NUMBER: 'Number',
                DATETIME: 'Date',
                SCORE: 'Rating',
                SORT: 'Sorting',
                UPLOAD: 'Upload',
                TIME: 'Time',
                TIMESTAMP: 'Timestamp',
                SELECT: 'Dropdown',
                MATRIX_RADIO: 'Matrix Single Choice',
                MATRIX_MULTI: 'Matrix Multiple Choice',
                MATRIX_BLANK: 'Matrix Fill-in',
                MATRIX_STATISTICS: 'Matrix Statistics',
                MATRIX_COMPOSITION: 'Matrix Composition',
                THERMODYNAMIC_CHART: 'Heatmap',
                COMBINATION: 'Combination',
                LOOP: 'Loop',
                AUTO_RECORD: 'Auto Record'
            }
        }
    },
    fixdata: {
        title: 'Fix Data Center',
        add: 'New Case',
        updateData: 'Update Data',
        updateDataConfirmTitle: 'Confirm',
        updateDataConfirmMessage: 'Run data update now?',
        updateDataConfirmOk: 'OK',
        updateDataConfirmCancel: 'Cancel',
        updateDataSuccess: 'Data updated',
        updateDataFail: 'Data update failed',
        syncQuota: 'Sync Quota',
        syncQuotaPromptTitle: 'Sync Quota',
        syncQuotaPromptMessage: 'Enter Project ID',
        syncQuotaPromptPlaceholder: 'e.g. 455',
        syncQuotaPromptOk: 'OK',
        syncQuotaPromptCancel: 'Cancel',
        syncQuotaInvalid: 'Project ID must be digits',
        syncQuotaSuccess: 'Quota sync triggered',
        syncQuotaFail: 'Quota sync failed',
        search: 'Search',
        searchPlaceholder: 'Search fix name',
        id: 'ID',
        name: 'Case Name',
        caseId: 'Fix ID',
        caseName: 'Fix Name',
        type: 'Type',
        typeFix: 'Fix',
        typeDiscard: 'Discarded',
        projectId: 'Project ID',
        projectName: 'Project Name',
        createdAt: 'Created At',
        desc: 'Description',
        recordsCount: 'Records',
        actions: 'Actions',
        edit: 'Edit',
        import: 'Import',
        delete: 'Delete',
        addDialogTitle: 'New Case',
        editDialogTitle: 'Edit Case',
        form: {
            name: 'Case Name',
            desc: 'Description',
            ok: 'OK',
            save: 'Save',
            confirm: 'Import'
        },
        upload: {
            rawHint: 'Drag CSV or Excel here, or ',
            clickToUpload: 'Click to upload',
            rawTip: 'Only .csv, .xlsx supported',
            rawTypeOnly: 'Only CSV or Excel files',
            rawSelected: 'File selected',
            rawSelectFirst: 'Please select a file first',
            rawSuccess: 'Import success',
            rawFail: 'Import failed'
        },
        importDialogTitle: 'Import Fix Data',
        message: {
            inputName: 'Please enter case name',
            saved: 'Saved',
            saveFail: 'Save failed'
        },
        deletion: {
            confirm: 'Delete “{name}”?',
            success: 'Deleted',
            fail: 'Delete failed'
        }
    },
    ops: {
        common: {
            confirm: 'Confirm',
            cancel: 'Cancel',
            refresh: 'Refresh'
        },
        data: {
            title: 'Ops Data',
            projectId: 'Project ID',
            projectName: 'Project Name',
            remark: 'Remark',
            isCurrent: 'Current',
            current: 'Current',
            notCurrent: 'Not Current',
            searchProjectNamePlaceholder: 'Search project name',
            searchProjectIdPlaceholder: 'Search project ID',
            search: 'Search',
            reset: 'Reset',
            actions: 'Actions',
            dataVersion: 'Data Version',
            import: 'Import',
            export: 'Export',
            restore: 'Apply',
            pullData: 'Pull Data',
            sync: 'Sync Versions',
            syncConfirmTitle: 'Confirm',
            syncConfirmAll: 'Sync init backup versions for all projects?',
            syncConfirmProject: 'Sync init backup versions for project {id}?',
            syncSuccess: 'Sync triggered',
            syncFail: 'Sync failed',
            pullConfirmMessage: 'Pull v1 data for project {id}?',
            pullSuccess: 'Pull triggered',
            pullFail: 'Pull failed',
            listFail: 'Failed to fetch list',
            exportFail: 'Export failed',
            restoreFail: 'Apply failed',
            importFail: 'Import failed',
            importSuccess: 'Import succeeded',
            versions: 'Versions',
            versionsDialogTitle: 'Project Versions (Project ID: {id})',
            versionsLoadFail: 'Failed to fetch project versions',
            downloadLatestData: 'Download Latest Data',
            downloadLatestDataFail: 'Failed to download latest data',
            versionId: 'Data Version ID',
            createdAt: 'Created At',
            delete: 'Delete',
            deleteConfirmTitle: 'Confirm',
            deleteConfirmMessage: 'Delete version record (ID: {id})?',
            deleteSuccess: 'Deleted',
            deleteFail: 'Delete failed: {msg}',
            importDialogTitle: 'Import Version (Project ID: {id})',
            importProjectId: 'Project ID',
            remarkPlaceholder: 'Optional',
            importFile: 'Excel File',
            importDropHint: 'Drop file here, or',
            importClick: 'click to upload',
            importTip: 'Only .xlsx, .xls',
            importFileRequired: 'Please select an Excel file',
            selectedFile: 'Selected: ',
            restoreConfirmTitle: 'Confirm',
            restoreConfirmMessage: 'Apply version {version} for project {id}? This will overwrite current data.',
            restoreSuccess: 'Apply succeeded'
        },
        quota: {
            title: 'Quota Cache',
            hint: 'Used to clear quota-related cache. It may take a while with large data volume.',
            clearAll: 'Clear All Cache',
            clearByProject: 'Clear by Project',
            allProjects: 'All Projects',
            clearingTip: 'Clearing cache, please wait...',
            clearSuccess: 'Cache clear triggered',
            clearFail: 'Clear failed: {msg}',
            clearAllConfirmTitle: 'Confirm',
            clearAllConfirmMessage: 'Clear quota cache for all projects?',
            projectPromptTitle: 'Clear by Project',
            projectPromptMessage: 'Enter Project ID',
            projectPromptPlaceholder: 'e.g. 455',
            projectInvalid: 'Project ID must be digits',
            logTime: 'Time',
            logProjectId: 'Project ID',
            logResult: 'Result',
            searchProjectNamePlaceholder: 'Search project name',
            searchProjectIdPlaceholder: 'Search project ID',
            search: 'Search',
            reset: 'Reset',
            projectId: 'Project ID',
            projectName: 'Project Name',
            projectDesc: 'Description',
            createTime: 'Created At',
            actions: 'Actions',
            syncQuota: 'Sync Quota',
            syncingTip: 'Syncing quota, please wait...',
            syncConfirmTitle: 'Confirm',
            syncConfirmMessage: 'Sync quota for project {id}?',
            syncSuccess: 'Sync triggered',
            syncFail: 'Sync failed: {msg}',
            listFail: 'Failed to fetch list'
        },
        activityMonitor: {
            title: 'Activity Monitor',
            window: 'Active Window',
            win3h: '3h',
            win6h: '6h',
            win12h: '12h',
            win1d: '1d',
            win3d: '3d',
            win5d: '5d',
            unitHour: 'Hour',
            unitDay: 'Day',
            unitWeek: 'Week',
            apply: 'Apply',
            windowInvalid: 'Please enter a valid window',
            projectId: 'Project ID',
            projectName: 'Project Name',
            projectStatus: 'Status',
            statusRun: 'Running',
            lastActiveTime: 'Last Active',
            activeAnswerCount: 'Active Answers',
            windowMinutes: 'Window',
            listFail: 'Failed to fetch list'
        },
        dataAdjust: {
            title: 'Data Adjust',
            searchProjectIdPlaceholder: 'Enter project ID',
            search: 'Search',
            reset: 'Reset',
            add: 'Add',
            addDialogTitle: 'Add Record',
            selectProject: 'Select Project',
            selectPlaceholder: 'Type to search',
            loadProjectsFail: 'Failed to load projects',
            downloadLatestData: 'Download Latest Data',
            downloadLatestDataFail: 'Failed to download latest data',
            exportOrigin: 'Export Origin',
            exportAdjust: 'Export Adjust',
            exportFail: 'Export failed',
            switchToOrigin: 'Switch to Origin',
            switchToAdjust: 'Switch to Adjust',
            editMode: 'Edit Mode',
            exitEdit: 'Exit Edit',
            editOnlyAdjust: 'Switch to Adjust first to edit',
            addSuccess: 'Added',
            addFail: 'Add failed',
            projectIdRequired: 'Please enter project ID',
            summaryTitle: 'Done Answers Summary',
            sourceOrigin: 'Origin',
            sourceAdjust: 'Adjust',
            questionNo: 'Question No',
            questionType: 'Type',
            questionId: 'Question ID',
            total: 'Total',
            valuesCount: 'Values',
            value: 'Value',
            count: 'Count',
            summaryFail: 'Failed to fetch summary',
            recordsTitle: 'Adjust Records',
            recordId: 'Record ID',
            projectId: 'Project ID',
            projectName: 'Project Name',
            createTime: 'Created At',
            updateTime: 'Updated At',
            actions: 'Actions',
            adjust: 'Adjust',
            adjustDialogTitle: 'Summary (Project ID: {id})',
            listFail: 'Failed to fetch list'
        }
    },
    olddata: {
        title: 'Historical Data',
        add: 'Add',
        searchPlaceholder: 'Search project name',
        search: 'Search',
        refresh: 'Refresh',
        id: 'Project ID',
        name: 'Project Name',
        type: 'Type',
        typeOld: 'Legacy',
        industry: 'Industry',
        company: 'Company',
        desc: 'Description',
        questionCount: 'Questions',
        answerCount: 'Responses',
        actions: 'Actions',
        preview: 'Preview',
        edit: 'Edit',
        view: 'View',
        delete: 'Delete',
        addDialogTitle: 'Add & Import Project',
        editDialogTitle: 'Edit Project',
        form: {
            name: 'Name',
            desc: 'Desc',
            company: 'Company',
            companyPlaceholder: 'Enter company name',
            category: 'Category',
            categoryPlaceholder: 'Select category',
            dataZip: 'Data ZIP',
            dataImported: 'Data Imported',
            dataCount: '{count} items',
            clear: 'Clear',
            rawData: 'Raw Data',
            next: 'Next',
            save: 'Save',
            ok: 'OK',
            prev: 'Previous',
            confirm: 'Confirm'
        },
        upload: {
            zipHint: 'Drag ZIP here, or ',
            clickToUpload: 'Click to upload',
            zipTip1: 'Only .zip is supported; updates item count after upload',
            zipTip2: 'Archive must include asc files and datamap.txt',
            zipOnly: 'Only ZIP files are allowed',
            zipSuccess: 'Legacy data imported',
            zipFail: 'Legacy data import failed',
            rawHint: 'Drag raw data here, or ',
            rawTip: 'Supports Excel (.xlsx/.xls) and .csv',
            rawSelectFirst: 'Please select a raw data file first',
            rawSuccess: 'Raw data imported',
            rawFail: 'Raw data import failed',
            rawTypeOnly: 'Only .csv/.xlsx/.xls files are allowed',
            rawSelected: 'Raw file selected; click Confirm to import'
        },
        clear: {
            confirm: 'Clear imported data?',
            success: 'Cleared',
            fail: 'Clear failed'
        },
        deletion: {
            confirm: 'Delete project “{name}”? This cannot be undone.',
            success: 'Deleted',
            fail: 'Delete failed'
        },
        previewDialog: {
            title: 'Project Preview',
            name: 'Name',
            desc: 'Description',
            tags: 'Tags',
            createdAt: 'Created At',
            updatedAt: 'Updated At',
            rowsCount: 'Items',
            close: 'Close',
            viewData: 'View Data'
        },
        message: {
            fetchListFail: 'Failed to fetch legacy projects',
            inputName: 'Please enter a name',
            saved: 'Changes saved',
            createSuccess: 'Created successfully',
            createFail: 'Create failed',
            refreshed: 'List refreshed'
        },
        detail: {
            back: 'Back',
            itemsTag: 'Items {count}',
            cross: 'Cross Analysis',
            exportCsv: 'Export CSV',
            selectQuestionPlaceholder: 'Select question No.',
            answerKeywordPlaceholder: 'Enter answer keyword',
            search: 'Search',
            text: 'Text',
            value: 'Value',
            status: 'Status',
            statusValues: {
                completed: 'Completed',
                inProgress: 'In Progress',
                failed: 'Failed'
            },
            crossDialog: {
                title: 'Cross Analysis',
                demo: 'This feature is under development. Stay tuned.',
                close: 'Close',
                ok: 'OK'
            },
            message: {
                fetchAnswersFail: 'Failed to fetch answers',
                fetchProjectFail: 'Failed to fetch project detail'
            }
        }
    },
    route: {
        dashboard: 'Dashboard',
        introduction: 'Introduction',
        documentation: 'Documentation',
        permission: 'Permission',
        pagePermission: 'Page Permission',
        directivePermission: 'Directive Permission',
        icons: 'Icons',
        components: 'Components',
        componentIndex: 'Introduction',
        tinymce: 'Tinymce',
        markdown: 'Markdown',
        jsonEditor: 'JSON Editor',
        dndList: 'Dnd List',
        splitPane: 'SplitPane',
        avatarUpload: 'Avatar Upload',
        dropzone: 'Dropzone',
        sticky: 'Sticky',
        countTo: 'CountTo',
        componentMixin: 'Mixin',
        backToTop: 'BackToTop',
        dragDialog: 'Drag Dialog',
        dragKanban: 'Drag Kanban',
        charts: 'Charts',
        keyboardChart: 'Keyboard Chart',
        lineChart: 'Line Chart',
        mixChart: 'Mix Chart',
        example: 'Example',
        Table: 'Table',
        dynamicTable: 'Dynamic Table',
        dragTable: 'Drag Table',
        inlineEditTable: 'Inline Edit',
        complexTable: 'Complex Table',
        treeTable: 'Tree Table',
        customTreeTable: 'Custom TreeTable',
        tab: 'Tab',
        form: 'Form',
        createForm: 'Create Form',
        editForm: 'Edit Form',
        errorPages: 'Error Pages',
        page401: '401',
        page404: '404',
        errorLog: 'Error Log',
        excel: 'Excel',
        exportExcel: 'Export Excel',
        selectExcel: 'Export Selected',
        uploadExcel: 'Upload Excel',
        zip: 'Zip',
        exportZip: 'Export Zip',
        theme: 'Theme',
        clipboardDemo: 'Clipboard',
        i18n: 'I18n'
    },
    navbar: {
        logOut: 'Log Out',
        dashboard: 'Dashboard',
        groupDaily: 'Daily',
        groupConfig: 'Config',
        groupAdvanced: 'Advanced',
        envProd: 'Prod',
        envTest: 'Test',
        envUnknown: 'Unknown Env',
        github: 'Github',
        screenfull: 'Screenfull',
        theme: 'Theme',
        projectManagement: 'Project Mgt',
        recycleBin: 'Recycle Bin',
        systemManagement: 'System Mgt',
        userManagement: 'User Mgt',
        roleManagement: 'Role Mgt',
        menuManagement: 'Menu Mgt',
        codeGeneration: 'Code Gen',
        projectList: 'Project List',
        automatedReport: 'Auto Report',
        favoritesCenter: 'Favorites',
        collaborativeSurvey: 'Co-op Survey',
        pushCenter: 'Push Center',
        systemSettings: 'System Settings'
    },
    login: {
        title: 'Login Form',
        logIn: 'Log in',
        username: 'Username',
        password: 'Password',
        any: 'any',
        thirdparty: 'Or connect with',
        thirdpartyTips: 'Can not be simulated on local, so please combine you own business simulation! ! !'
    },
    publicSite: {
        navigation: 'YiSurvey public navigation',
        brandName: 'YiSurvey',
        brandAlt: 'YiSurvey logo',
        brandSubtitle: 'YiSurvey Platform',
        home: 'Home',
        capabilities: 'Capabilities',
        pricing: 'Pricing',
        contact: 'Contact',
        login: 'Login',
        register: 'Register'
    },
    landingPage: {
        revealEyebrow: 'Survey Intelligence Online',
        taglinePlain: 'Turn every question into actionable insight',
        heroEyebrow: 'Survey Intelligence Platform',
        productName: 'Survey Platform',
        heroTagline: 'Turn every question into actionable insight.',
        heroDescription: 'Bring questionnaire design, sample delivery, quota monitoring, and data insight into one clear, collaborative, and traceable research system.',
        demoCta: 'Book a demo',
        pricingCta: 'View pricing',
        dashboardCta: 'Open workspace',
        heroProofs: ['Questionnaire design', 'Sample quotas', 'Live monitoring', 'Data insights'],
        engineTitle: 'Survey Intelligence Engine',
        engineLabel: 'Valid sample signal',
        stage: {
            questionKicker: 'Questionnaire design',
            questionTitle: 'Brand awareness study',
            sampleKicker: 'Sample flow',
            responseCount: '2,847 responses',
            quotaKicker: 'Quota monitoring',
            quotaLabel: 'Region / Age / Channel',
            insightKicker: 'Live insights',
            logicChip: 'Smart logic',
            cleanChip: 'Clean data'
        },
        workflowEyebrow: 'YiSurvey Workflow',
        workflowTitle: 'From project setup to final report, move every step forward in one system.',
        workflowDescription: 'YiSurvey brings questionnaire design, publishing, quota monitoring, data correction, statistical exports, and focused analysis together so research teams can switch tools less and retain more reusable assets.',
        visual: {
            projectQuestion: 'Put every research project into one traceable workspace.',
            projectTags: ['Create project', 'Question count', 'Collection progress', 'Copy share code'],
            logicTitle: 'Logic',
            logicPreview: 'Skip / Copy / Script preview',
            designChannels: ['Core question types', 'Loops', 'MaxDiff', 'AI scripts', 'Multilingual'],
            launchLabel: 'Launch / Quota / Email',
            quotaBadge: 'Quota completion',
            analysisLabel: 'Data / Analysis / Report',
            insightHeadline: 'Review, correct, export, and analyze data in one continuous workflow.',
            analysisActions: ['Excel / SPSS', 'Audio export', 'Data correction', 'Open-text analysis', 'Automated reports']
        },
        evidenceEyebrow: 'Evidence Chain',
        evidenceTitle: 'Turn every question into actionable insight.',
        evidenceDescription: 'Research is proven by its traceable deliverables, not a decorative dashboard: project brief, questionnaire, launch, quota records, dataset, and analysis.',
        caseFileTitle: 'New package awareness study',
        caseFileMeta: ['28 questions', '1,426 responses', '6 quota dimensions'],
        caseFileStamp: 'Traceable',
        useCaseEyebrow: 'Use Cases',
        useCaseTitle: 'From one package test, ',
        useCaseTitleAccent: 'to continuous brand tracking.',
        useCaseDescription: 'YiSurvey supports projects that require questionnaire design, sample control, structured data, and analytical delivery. Every scenario follows the same research workflow while preserving its own evidence trail.',
        scenarioBoardLabel: 'Research Scenario Board',
        sharedFlowLabel: 'Shared workflow',
        sharedFlowValue: 'Questionnaire design / Launch and collection / Quota monitoring / Data delivery',
        contactEyebrow: 'Demo Access',
        contactTitle: 'Ready to bring your research workflow into YiSurvey?',
        contactDescription: 'Book a demo or explore pricing for teams of different sizes.',
        scenes: {
            project: {
                label: 'Project Hub',
                title: 'Start every project in one workspace.',
                desc: 'Create, duplicate, move, close, extend, and archive projects in one place, with question counts, distribution volume, and completions visible in the project list.',
                points: ['Project creation', 'Folder archive', 'Questions / responses']
            },
            design: {
                label: 'Question Designer',
                title: 'Build complex questionnaires in the designer.',
                desc: 'Core question types, logic, loops, MaxDiff, pre- and post-scripts, AI scripts, multilingual content, and resource management live in one design surface.',
                points: ['Question components', 'Logic / scripts', 'Loops / MaxDiff']
            },
            launch: {
                label: 'Launch Control',
                title: 'Coordinate launch, links, quotas, and outreach.',
                desc: 'Publishing, historical links, link settings, quota plans, quota monitoring, email templates, senders, audience groups, and delivery records support collection together.',
                points: ['Launch links', 'Quota plans', 'Email outreach']
            },
            analysis: {
                label: 'Data & Report',
                title: 'Keep processing and analyzing after collection.',
                desc: 'Response data, statistical views, Excel / SPSS / audio exports, data correction, quota sync, open-text analysis, naming tests, product trials, and automated reports close the loop.',
                points: ['Data exports', 'Data correction', 'Focused analysis']
            }
        },
        evidenceSteps: {
            project: {
                label: 'Project Brief',
                title: 'Project setup',
                desc: 'Project name, status, folder, question count, and response volume are recorded first.',
                artifacts: ['Project list', 'Status filters', 'Share code']
            },
            questionnaire: {
                label: 'Questionnaire',
                title: 'Questionnaire structure',
                desc: 'Question components, outlines, libraries, loops, and MaxDiff form an editable structure.',
                artifacts: ['Components', 'Outline', 'MaxDiff']
            },
            launch: {
                label: 'Launch Link',
                title: 'Launch and collection',
                desc: 'Published projects, historical links, link settings, and email outreach stay tied to one project.',
                artifacts: ['Launch links', 'Link history', 'Email templates']
            },
            quota: {
                label: 'Quota Record',
                title: 'Quota records',
                desc: 'Sample status, success rate, quota plans, and matrices preserve the execution history.',
                artifacts: ['Sample metrics', 'Quota matrix', 'Completion rate']
            },
            dataset: {
                label: 'Dataset',
                title: 'Data delivery',
                desc: 'Response review, data correction, and Excel / SPSS / audio exports form the delivery package.',
                artifacts: ['Excel', 'SPSS', 'Audio']
            },
            insight: {
                label: 'Insight',
                title: 'Focused analysis',
                desc: 'Open-text, naming, and product trial analysis turn collected data into decisions.',
                artifacts: ['Open text', 'Naming test', 'Product trial']
            }
        },
        useCases: {
            brand: {
                label: 'Brand & Package',
                period: '2-4 weeks',
                title: 'Brand and package testing',
                desc: 'Measure awareness, preference, purchase intent, and open feedback after consumers see a package, concept, or brand message.',
                flow: ['Package concept', 'Awareness and preference', 'Open feedback'],
                deliverables: ['Excel / SPSS', 'Open-text analysis', 'Decision record']
            },
            trial: {
                label: 'Product Trial',
                period: 'On-site / In-home',
                title: 'New product and taste testing',
                desc: 'Combine quota screening, experience records, naming tests, and product trial analysis to support pre-launch decisions.',
                flow: ['Quota screening', 'Experience record', 'Product comparison'],
                deliverables: ['Quota monitoring', 'Product analysis', 'Naming test']
            },
            tracking: {
                label: 'Tracking Study',
                period: 'Monthly / Quarterly',
                title: 'Continuous brand tracking',
                desc: 'Reuse historical projects, question libraries, terminology, and data versions to turn recurring collection into comparable trend assets.',
                flow: ['Project duplication', 'Recurring collection', 'Trend history'],
                deliverables: ['Link history', 'Data versions', 'Periodic report']
            }
        }
    },
    loginPage: {
        kickedTitle: 'Signed in elsewhere',
        kickedDesc: 'Your account was signed in on another device, so this device has been signed out. If this was not you, please change your password immediately.',
        loginTitle: 'Login',
        username: 'Username',
        usernameLogin: 'Username / Mobile',
        loginModePassword: 'Password',
        loginModeSms: 'SMS Code',
        loginModeLabel: 'Login method',
        password: 'Password',
        forgotPassword: 'Forgot Password?',
        login: 'Login',
        orLoginWith: 'or login with social platforms',
        registerTitle: 'Register',
        register: 'Register',
        orRegisterWith: 'or register with social platforms',
        hello: 'Hello, Welcome',
        noAccount: "Don't have an account?",
        toRegister: 'Register',
        welcomeBack: 'Welcome Back!',
        hasAccount: 'Already have an account?',
        toLogin: 'Login',
        usernameRequired: 'Please enter username',
        usernameInvalid: 'Username must contain letters',
        passwordRequired: 'Please enter password',
        loginSuccess: 'Login successful',
        loginFailed: 'Login failed. Please try again later',
        invalidCredentials: 'Invalid username or password',
        accountNotFound: 'Username does not exist',
        mobileNotRegistered: 'This phone number is not registered',
        passwordIncorrect: 'Incorrect password',
        pricingPlans: 'Pricing',
        authEyebrow: 'YiSurvey / PUBLIC ACCESS',
        authHeadlinePrimary: 'Start with a question,',
        authHeadlineAccent: 'bring the answer back to your team.',
        authDescription: 'Sign in to manage questionnaires, samples, responses, and research insights in YiSurvey.',
        flowQuestionnaire: 'Questionnaire',
        flowLaunch: 'Launch',
        flowCollection: 'Collection',
        flowInsight: 'Insight',
        workspaceReady: 'Workspace ready',
        workspaceTraceable: 'Traceable process',
        workspaceCollaborative: 'Team collaboration',
        authModeLabel: 'Login or register',
        loginKicker: 'RETURN TO YOUR WORKSPACE',
        registerKicker: 'START A NEW STUDY',
        loginSubtitle: 'Continue your research work with your account.',
        registerSubtitle: 'Create an account for your next study.',
        usernamePlaceholder: 'Username / Mobile',
        passwordPlaceholder: 'Enter password',
        mobile: 'Mobile number',
        mobilePlaceholder: 'Enter mobile number',
        mobileRequired: 'Please enter mobile number',
        mobileInvalid: 'Please enter a valid mainland China mobile number',
        smsCode: 'SMS code',
        smsCodePlaceholder: 'Enter verification code',
        smsCodeRequired: 'Please enter SMS code',
        smsCodeInvalid: 'SMS code is invalid or expired',
        sendSmsCode: 'Send code',
        smsCountdown: 'Resend in {seconds}s',
        smsSent: 'Verification code sent. Please check your phone.',
        smsTooFrequent: 'Too many code requests. Please wait and try again.',
        smsSendFailed: 'Failed to send verification code. Please try again later.',
        email: 'Email',
        emailOptional: 'Email (optional)',
        emailPlaceholder: 'Enter work email',
        emailRequired: 'Please enter email',
        emailInvalid: 'Please enter a valid email address',
        loggingIn: 'Signing in...',
        registering: 'Creating account...',
        contactSupport: 'Need help signing in? Contact support',
        supportSubject: 'YiSurvey login support',
        registerSuccess: 'Registration successful. Sign in with your new account.',
        registerFailed: 'Registration failed. Please try again later.',
        mobileExists: 'Mobile number already registered',
        accountExists: 'Username, mobile number, or email already exists'
    },
    documentation: {
        documentation: 'Documentation',
        github: 'Github Repository'
    },
    // ===== Realtime collaboration (editor WebSocket) =====
    collab: {
        online: 'Online collaborators',
        someone: 'A collaborator',
        updated: 'updated',
        isEditing: 'is editing',
        updatedBadge: 'Updated by {name}',
        loadLatest: 'Load latest',
        overwrite: 'Overwrite with mine',
        loadLatestBtn: 'Load their version',
        conflictTitle: 'Save conflict',
        conflictDesc: 'This question has been modified by another collaborator. Your changes have not been saved.',
        conflictTip: '"Overwrite with mine" replaces their changes with yours; "Load their version" discards your changes.',
        overwriteSuccess: 'Overwritten and saved',
        overwriteFail: 'Failed to overwrite',
        loadedLatest: 'Latest version loaded',
        reconnecting: 'Realtime collaboration disconnected, reconnecting...',
        degraded: 'Realtime collaboration is temporarily unavailable (retrying automatically)'
    },
    permission: {
        roles: 'Your roles',
        switchRoles: 'Switch roles'
    },
    components: {
        documentation: 'Documentation',
        tinymceTips: 'Rich text editor is a core part of management system, but at the same time is a place with lots of problems. In the process of selecting rich texts, I also walked a lot of detours. The common rich text editors in the market are basically used, and the finally chose Tinymce. See documentation for more detailed rich text editor comparisons and introductions.',
        dropzoneTips: 'Because my business has special needs, and has to upload images to qiniu, so instead of a third party, I chose encapsulate it by myself. It is very simple, you can see the detail code in @/components/Dropzone.',
        stickyTips: 'when the page is scrolled to the preset position will be sticky on the top.',
        backToTopTips1: 'When the page is scrolled to the specified position, the Back to Top button appears in the lower right corner',
        backToTopTips2: 'You can customize the style of the button, show / hide, height of appearance, height of the return. If you need a text prompt, you can use element-ui el-tooltip elements externally',
        imageUploadTips: 'Since I was using only the vue@1 version, and it is not compatible with mockjs at the moment, I modified it myself, and if you are going to use it, it is better to use official version.'
    },
    table: {
        dynamicTips1: 'Fixed header, sorted by header order',
        dynamicTips2: 'Not fixed header, sorted by click order',
        dragTips1: 'The default order',
        dragTips2: 'The after dragging order',
        title: 'Title',
        importance: 'Imp',
        type: 'Type',
        remark: 'Remark',
        reviewer: 'reviewer',
        id: 'ID',
        date: 'Date',
        author: 'Author',
        readings: 'Readings',
        status: 'Status',
        publish: 'Publish',
        draft: 'Draft',
    },
    errorLog: {
        tips: 'Please click the bug icon in the upper right corner',
        description: 'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
        documentation: 'Document introduction'
    },
    excel: {
        export: 'Export',
        selectedExport: 'Export selected items',
        placeholder: 'Please enter the file name(default excel-list)'
    },
    zip: {
        export: 'Export',
        placeholder: 'Please enter the file name(default file)'
    },
    theme: {
        change: 'Theme change',
        documentation: 'Theme documentation',
        tips: 'Tips: It is different from the theme-pick on the navbar is two different skinning methods, each with different application scenarios. Refer to the documentation for details.'
    },
    tagsView: {
        close: 'Close',
        closeOthers: 'Close Others',
        closeAll: 'Close All'
    },
    dashboard: {
        kpi: {
            surveyCount: "Surveys",
            userCount: "Users",
            ongoingSurvey: "Ongoing Surveys",
            recoveryRate: "Survey Recovery Rate"
        },
        hero: {
            badge: "YISURVEY · SMART SURVEY SYSTEM",
            title: "Integrated Survey Design and Data Insight Platform",
            desc: "Supports survey editing, complex logic orchestration, script extension, and sample/quota management, helping teams quickly build high-quality research projects and continuously track outcomes.",
            enterProjectList: "Go To Project List",
            signalRealtime: "Real-time Collection",
            signalSmart: "Smart Screening",
            cube: {
                survey: "Survey",
                sample: "Sample",
                logic: "Logic",
                quota: "Quota",
                insight: "Insight",
                analysis: "Analysis"
            }
        },
        entry: {
            editorTitle: "Survey Editor",
            editorDesc: "Build question structures visually, with batch maintenance, template reuse, and multilingual extension.",
            logicTitle: "Logic and Script Capabilities",
            logicDesc: "Supports skip logic, display conditions, quota rules, and script handling for complex business scenarios.",
            deliveryTitle: "Distribution and Analysis Loop",
            deliveryDesc: "Covers link distribution, sample collection, quality screening, and result analysis to improve research efficiency."
        },
        trend: "Data Trend Statistics",
        client: "Client",
        browser: "Browser",
        system: "System",
        newSurvey: "New Survey",
        announcement: "Announcement"
    },
    project: {
        collaborator: {
            sharedWithMe: 'Shared with me',
            readonly: 'View only',
            share: 'Share',
            view: 'View',
            sharedFrom: 'Shared by',
            title: 'Share project',
            tip: 'Shared members can view the latest content of this project (questions, settings, responses, statistics) but cannot modify it.',
            searchPlaceholder: 'Search by account or name (at least 2 characters)',
            search: 'Search',
            searchResult: 'Search results',
            invite: 'Invite',
            memberList: 'Shared members',
            emptyMembers: 'Not shared with anyone yet',
            emptySearch: 'No matching user found',
            remove: 'Remove',
            close: 'Close',
            readonlyTip: 'This project is shared with you with view-only access. You can browse the content but cannot modify it.',
            needKeyword: 'Please enter at least 2 characters',
            inviteSuccess: 'Shared with this user',
            inviteFail: 'Failed to share',
            removeSuccess: 'Member removed',
            removeFail: 'Failed to remove',
            sidebarReadonlyTip: 'View-only share: you can browse but not modify',
            bannerPrefix: 'This project is shared with you by',
            bannerSuffix: '. You can view everything (including responses and statistics) but cannot modify it.',
            otherUser: 'another user',
            tip2: 'Invited members can view this project only after accepting. Once accepted they can view questions, settings, responses and statistics, but cannot modify them.',
            inviteSent: 'Invitation sent, waiting for confirmation',
            statusPending: 'Pending',
            statusAccepted: 'Joined',
            statusRejected: 'Declined',
            reinvite: 'Invite again',
            invitePanelTitle: 'You have new project sharing invitations',
            collapse: 'Collapse',
            expand: 'Expand',
            invitedBy: 'From',
            accept: 'Accept',
            reject: 'Decline',
            acceptSuccess: 'Invitation accepted, project added to your list',
            acceptFail: 'Failed to accept invitation',
            rejectSuccess: 'Invitation declined',
            rejectFail: 'Failed to decline invitation',
            searchFailed: 'Search failed',
            tip3: 'Configure per-module permissions: modules set to "View only" can only be browsed; modules set to "Can edit" can be modified. Takes effect after the invitee confirms; unauthorized modules are completely invisible to them.',
        },
        permission: {
            module: 'Module',
            none: 'None',
            read: 'View only',
            write: 'Can edit',
            editButton: 'Edit permissions',
            configTitle: 'Configure permissions',
            configTitleEdit: 'Edit permissions',
            save: 'Save',
            saveSuccess: 'Permissions updated',
            saveFail: 'Failed to update permissions',
            defaultTip: 'All modules default to "View only"; adjust the levels as needed before sending the invitation.',
            pureReadOnlyTip: '"Data download" and "Statistics" are view-only modules and have no "Can edit" level.',
            dataWriteTip: 'Set "Responses" to "Can edit" to change response status or delete responses (including batch ops on the data page); "View only" can browse responses only.',
            moreItems: '+{n} more',
            modules: {
                design: 'Questionnaire design',
                setting: 'Questionnaire settings',
                data: 'Responses',
                download: 'Data download',
                statistics: 'Statistics',
                quota: 'Quota management',
                publish: 'Publish & collect'
            }
        },
        transfer: {
            title: 'Transfer project',
            action: 'Transfer',
            ownerLabel: 'Project owner',
            tipShort: 'After transfer, the project owner changes and you will no longer have management access to this project.',
            tip: 'After transfer, the project owner will change to the new user and you will immediately lose all access to this project (including read-only viewing). This cannot be undone.',
            projectCount: 'Projects to transfer',
            newOwner: 'New owner',
            searchPlaceholder: 'Search by username or name (at least 2 characters)',
            search: 'Search',
            searchResult: 'Search results',
            select: 'Select',
            change: 'Change',
            emptySearch: 'No matching user found',
            needKeyword: 'Please enter at least 2 characters',
            noProject: 'Please select a project to transfer',
            searchFailed: 'Search failed',
            confirm: 'Confirm transfer',
            confirmTitle: 'Confirm project transfer',
            confirmMessage: 'Transfer {count} project(s) to {name}? You will lose all access to these projects afterwards, and this cannot be undone.',
            success: 'Transferred {count} project(s)',
            fail: 'Transfer failed',
        },
        id: "Project ID",
        name: "Project Name",
        nameOrId: "Project name / ID",
        status: "Status",
        createTime: "Created At",
        creator: "Creator",
        all: "All",
        design: "Designing",
        progress: "In Publication",
        paused: "Paused",
        completed: "Completed",
        expireOverlayText: 'Project expired, please close or extend',
        extendProject: 'Extend',
        closeProject: 'Close',
        extendSuccess: 'Extended successfully',
        extendFail: 'Extension failed',
        closeSuccess: 'Project closed',
        closeFail: 'Close failed',
        closeProjectTitle: 'Close Project',
        closeProjectTip: 'Survey links will be inaccessible after closing. Confirm?',
        noData: "No Data",
        stats: "Statistics",
        search: "Search",
        quotaMonitor: 'Quota Monitor',
        metrics: {
            questions: 'Questions',
            launch: 'Launches',
            answers: 'Responses'
        },
        folder: {
            more: 'More',
            newFolder: 'New Folder',
            rename: 'Rename',
            adjustOrder: 'Adjust Order',
            cancelClassification: 'Remove from Folder',
            assignToFolder: 'Add to Folder',
            createFolderTitle: 'Create Folder',
            editFolderTitle: 'Edit Folder',
            sortFolderTitle: 'Adjust Order',
            assignToFolderTitle: 'Add to Folder',
            nameLabel: 'Name',
            sortLabel: 'Order',
            selectFolderLabel: 'Select Folder',
            selectFolderPlaceholder: 'Select a folder'
        },
        quotaMonitorView: {
            title: 'Quota Monitor',
            panelFilterLabel: 'Select panel',
            panelAll: 'All',
            panelPlaceholder: 'Please select panel',
            refresh: 'Refresh Data',
            back: 'Back',
            noQuota: 'Quota not enabled',
            noQuotaTip: 'Please configure quotas first, then start collecting responses',
            currentAnswerCount: 'Current Answers',
            quotaStatus: 'Quota Status',
            enabled: 'Enabled',
            disabled: 'Disabled',
            schemeDetails: 'Quota Scheme Details',
            matrixDetails: 'Quota Matrix Details',
            option: 'Option',
            quotaFull: 'Quota Full',
            noSchemeData: 'No quota data',
            loadFail: 'Failed to load quota data',
            retry: 'Retry',
            messages: {
                dataRefreshed: 'Data refreshed'
            }
        },
        sampleStatistics: {
            title: 'Sample Statistics',
            success: 'Successful Samples',
            overQuota: 'Over-Quota Samples',
            screened: 'Screened Samples',
            unfinished: 'Unfinished Samples',
            discarded: 'Discarded Samples',
            totalClicks: 'Link Clicks',
            successRate: 'Success Rate',
            loadFail: 'Failed to load sample statistics'
        },
        config: {
            config: 'Config',
            info: 'Info',
            link: 'Link',
            settings: 'Settings',
            thirdParty: 'Third Party Config',
            language: 'Language',
            display: 'Display',
            status: 'Status',
            quota: 'Quota',
            share: 'Share',
            baseInfo: 'Basic Info',
            projectName: 'Project Name',
            projectDescription: 'Project Description',
            organization: 'Organization',
            creator: 'Creator',
            createTime: 'Created At',
            updateTime: 'Updated At',
            save: 'Save',
            linkSettings: 'Link Settings',
            surveyLink: 'Survey Link',
            shareLink: 'Share Link',
            copy: 'Copy',
            baseSettings: 'Basic Settings',
            surveyStatus: 'Survey Status',
            on: 'On',
            off: 'Off',
            allowRepeat: 'Allow Repeat Submission',
            showProgress: 'Show Progress Bar',
            thirdPartyIntegration: 'Third Party Integration',
            wechat: 'WeChat Integration',
            workWechat: 'WeCom',
            dingtalk: 'DingTalk',
            languageSettings: 'Language Settings',
            defaultLanguage: 'Default Language',
            supportedLanguages: 'Supported Languages',
            zhCN: 'Simplified Chinese',
            enUS: 'English',
            displaySettings: 'Display Settings',
            themeColor: 'Theme Color',
            fontSize: 'Font Size',
            showLogo: 'Show Logo',
            projectStatus: 'Project Status',
            currentStatus: 'Current Status',
            startTime: 'Start Time',
            endTime: 'End Time',
            quotaManage: 'Quota Management',
            surveyLimit: 'Survey Quota',
            storageLimit: 'Storage Space',
            apiLimit: 'API Call Limit',
            unitMB: 'MB',
            linkCopied: 'Link copied to clipboard',
            saving: 'Configuration saved',
            copySuccess: 'Copy successful',
            copyFailed: 'Copy failed',
            saveSuccess: 'Save successful',
            saveFailed: 'Save failed',
            fetchInfoFail: 'Failed to fetch project info',
            finishConfirmTitle: 'Set Project to Completed',
            finishConfirmMessage: 'After setting the project status to "Completed", the online survey will be locked and can no longer be answered or edited. Continue?',
            finishConfirmButton: 'Save and Lock',
            ongoing: 'Ongoing',
            finished: 'Finished',
            paused: 'Paused',
            deleted: 'Deleted',
        },
        share: {
            generateTitle: 'Generate Share Code',
            sourceProjectId: 'Source Project ID',
            keepLogic: 'Keep Logic',
            keepScript: 'Keep Script',
            keepI18n: 'Keep i18n',
            keepPanel: 'Keep Panel',
            keepQuota: 'Keep Quota',
            generate: 'Generate',
            generateSuccess: 'Generated successfully',
            generateFail: 'Failed to generate',
            shareCode: 'Share Code',
            copy: 'Copy',
            copyTitle: 'Copy Project from Share Code',
            inputShareCode: 'Share Code',
            shareCodePlaceholder: 'Paste shareCode (body.sig)',
            newProjectName: 'New Project Name',
            projectNameOptional: 'Optional: defaults to "sourceProjectName_copy"',
            description: 'Description',
            descriptionPlaceholder: 'Optional',
            organization: 'Organization',
            organizationPlaceholder: 'Optional',
            copyAction: 'Copy Project',
            copySuccess: 'Copied successfully',
            copyFail: 'Copy failed'
        },
        linkConfig: {
            refresh: 'Refresh',
            latestLinks: 'Latest Links',
            historyLinks: 'History Links',
            noLinks: 'No {type}',
            filterLabel: 'Filters',
            selectTypePlaceholder: 'Select Type',
            all: 'All',
            prod: 'Production',
            test: 'Test',
            offline: 'Offline',
            columns: {
                id: 'ID',
                linkUrl: 'Link URL',
                type: 'Type',
                createTime: 'Created At',
                status: 'Status',
                version: 'Version',
                tags: 'Tags',
                actions: 'Actions'
            },
            tags: {
                idCtrl: 'Survey ID Control',
                ipCtrl: 'IP Control',
                guidCtrl: 'GUID Control',
                breakpointCtrl: 'Breakpoint Control',
                isNav: 'Show Navbar',
                isPre: 'Show Previous Button',
                isAgain: 'Offline Link Avoid Re-answer',
                offline: 'Offline Link Avoid Re-answer',
                isTest: 'Test'
            },
            noLatestLinks: 'No links found',
            noHistoryLinks: 'No history links',
            loadFail: 'Failed to load links',
            loadHistoryFail: 'Failed to load history links',
            testLink: 'Test Link',
            prodLink1: 'Official Link 1',
            prodLink2: 'Official Link 2',
            offlineVersion: 'Offline Version',
            custom: 'Custom',
            unknownLink: 'Unknown Link',
            disableConfirm: 'Are you sure to disable this link?',
            disableConfirmTitle: 'Disable Link',
            disableConfirmButton: 'Disable',
            enableConfirm: 'Are you sure to enable this link?',
            enableConfirmTitle: 'Enable Link',
            enableConfirmButton: 'Enable',
            version: 'Version',
            typeLabel: 'Type',
            category: 'Category',
            enabledTip: 'Link enabled',
            disabledTip: 'Link disabled',
            operationFail: 'Operation failed, please retry'
        },
        languageConfig: {
            enableI18n: 'Enable i18n',
            modeLabel: 'Language Mode',
            modeOff: 'Disabled',
            modeMulti: 'Multi-language',
            modeSingle: 'Single language',
            selectDefaultPlaceholder: 'Select default language',
            fetchFail: 'Failed to fetch language configuration',
            defaultMustInSupported: 'Default language must be in supported list',
            supportedRequired: 'Please select at least one supported language',
            saveSuccess: 'Language configuration saved',
            saveFail: 'Failed to save language configuration',
            langNames: {
                cn: 'Chinese',
                zh_TW: 'Traditional Chinese',
                cantonese: 'Cantonese',
                en: 'English',
                th: 'Thai',
                fr: 'French',
                ru: 'Russian',
                ar: 'Arabic',
                es: 'Spanish',
                de: 'German',
                pt: 'Portuguese',
                jp: 'Japanese',
                hi: 'Hindi',
                it: 'Italian',
                pl: 'Polish',
                ms: 'Malay',
                vi: 'Vietnamese',
                tl: 'Tagalog',
                id: 'Indonesian',
                my: 'Burmese',
                ko: 'Korean',
                la: 'Latin',
            }
        },
        quotaSchemeList: {
            backToProjectConfig: 'Back to Project Config',
            title: 'Quota Scheme Management',
            listTitle: 'Quota Schemes',
            refresh: 'Refresh',
            refreshSuccess: 'Refreshed',
            create: 'Create Quota Scheme',
            loading: 'Loading...',
            emptyTitle: 'No quota schemes',
            emptyDesc: 'Create your first quota scheme to start managing quotas',
            emptyHint: 'Click the button on the right to create the first scheme',
            noDescription: 'No description',
            totalQuota: 'Total Quota',
            usedQuota: 'Used',
            configureQuota: 'Configure Quota',
            configured: 'Configured',
            dialog: {
                createTitle: 'Create Quota Scheme',
                editTitle: 'Edit Quota Scheme',
                addControlTitle: 'Add Quota Control',
                create: 'Create',
                save: 'Save'
            },
            form: {
                name: 'Scheme Name',
                description: 'Scheme Description',
                status: 'Enabled',
                namePlaceholder: 'Enter scheme name',
                descriptionPlaceholder: 'Enter scheme description (optional)',
                rules: {
                    nameRequired: 'Please enter scheme name',
                    nameLength: 'Length must be between 2 and 50 characters'
                }
            },
            messages: {
                loadFail: 'Failed to load quota schemes',
                copySuccess: 'Quota scheme duplicated',
                copyFail: 'Failed to duplicate quota scheme',
                deleteConfirmText: 'Delete quota scheme "{name}"?',
                deleteConfirmTitle: 'Confirm Delete',
                deleteSuccess: 'Deleted successfully',
                deleteFail: 'Delete failed',
                createSuccess: 'Created successfully',
                updateSuccess: 'Updated successfully',
                createFail: 'Create failed',
                updateFail: 'Update failed'
            },
            copySuffix: ' - Copy'
        },
        quotaConfig: {
            backToSchemeList: 'Back to Quota Schemes',
            title: 'Quota Settings',
            enableControl: 'Enable quota control',
            enableHint: 'Note: After enabling, responses will be limited by quotas. When quotas are reached, responses cannot continue.',
            advancedTitle: 'Advanced Quota Settings',
            stubLabel: 'STUB question (row):',
            headerLabel: 'HEADER question (column):',
            baseLabel: 'BASE filter question:',
            baseDimensionLabel: 'BASE question:',
            selectStubPlaceholder: 'Select STUB question',
            selectHeaderPlaceholder: 'Select HEADER question',
            selectBasePlaceholder: 'Select BASE question',
            quotaTableTitle: 'Quota Allocation Table',
            currentTotal: 'Current quota total: ',
            baseFilterLabel: 'BASE filter:',
            selectFilterPlaceholder: 'Select filter',
            total: 'Total',
            option: 'Option',
            quota: 'Quota',
            share: 'Share',
            status: 'Status',
            statusUnset: 'Not set',
            statusUnlimited: 'Unlimited',
            statusBlocked: 'Blocked',
            statusLimited: 'Limited',
            rowTotal: 'Row Total',
            columnTotal: 'Column Total',
            hintsTitle: 'Quota Settings Notes',
            hintNoLimit: 'A quota value of -1 means no limit for the combination',
            hintNotAllowed: 'A quota value of 0 means the combination is not allowed',
            hintPositive: 'A positive quota value means the maximum allowed count for the combination',
            hintGrandTotal: 'The total automatically sums valid quota values (excluding -1 and 0)',
            hintEffectiveStage: 'Quota control only applies during data collection',
            saveSettings: 'Save Quota Settings',
            reset: 'Reset',
            currentSchemePrefix: 'Current scheme: ',
            noSelectionTip1: 'Select a quota scheme on the left to configure',
            noSelectionTip2: 'Or click the button above to create a new quota control scheme',
            messages: {
                loadQuotaFail: 'Failed to load quota data',
                loadQuestionsFail: 'Failed to load questions',
                saveSuccess: 'Quota settings saved',
                saveFail: 'Failed to save quota settings'
            },
            unnamedQuestion: 'Untitled Question',
            unknownQuestion: 'Unknown Question',
            noOptions: 'No configurable options for this question',
            progressPauseTitle: 'Auto-pause by quota progress',
            progressPauseDesc: 'When the configured progress is reached, the project is ended automatically and new link visits are paused. Set the project back to Running to monitor the next threshold.',
            progressCurrent: 'Current',
            progressCompleted: '{done} / {total} completed',
            progressNext: 'Next pause',
            progressThresholds: 'Pause thresholds',
            progressAdd: 'Add',
            progressThresholdPlaceholder: '1-99',
            progressThresholdRequired: 'Set at least one pause threshold',
            progressThresholdInvalid: 'Threshold must be an integer from 1 to 99',
            progressThresholdDuplicate: 'This threshold already exists',
            progressNotEligible: 'The scheme has unlimited quotas or a total quota of 0, so progress cannot be calculated',
            progressPausedAt: 'Auto-paused at {time} after reaching {threshold}%',
            progressProjectEnded: 'Project ended. Set it back to Running to monitor the next threshold',
            progressProjectPaused: 'Project paused. Set it back to Running to monitor the next threshold',
            progressMonitorActive: 'Monitoring',
            progressMonitorOff: 'Off',
            progressStatusPaused: 'Paused',
            progressStatusEnded: 'Project ended',
            progressStatusUnavailable: 'Unavailable',
            progressStatusPending: 'Pending publish',
            progressPendingPublish: 'The project is in design. Monitoring starts after it is published.',
            progressRefresh: 'Refresh progress',
            progressLoading: 'Loading',
            quotaMode: {
                matrix: 'STUB×HEADER Matrix Mode',
                single: 'STUB Single-Dimension Mode',
                unconfigured: 'Unconfigured'
            },
            optionLabelDefault: 'Option'
        },
        responses: "Responses",
        views: "Views",
        completion: "Completion Rate",
        emptyTip: "No Data",
        emptyCreate: "Create Project",
        deleteSuccess: "Deleted Successfully",
        deleteFail: "Delete Failed",
        confirmDelete: "Confirm Delete",
        confirmDeleteTip: "Are you sure you want to delete the project \"{name}\"?",
        createProject: {
            createProject: "Create Project",
            selectType: 'Select Project Type',
            regular: 'Regular Survey',
            regularDesc: 'Create a new survey project from scratch',
            template: 'Import Template',
            templateDesc: 'Quickly create a project from a preset template',
            copy: 'Copy Project',
            copyDesc: 'Create a copy based on an existing project',
            shareCode: 'Copy from Share Code',
            shareCodeDesc: 'Copy a project using a share code',
            ai: 'AI Parse',
            aiDesc: 'Automatically generate survey structure using AI',
            aiBadge: 'Beta',
            downloadExcelTemplate: 'Download Excel Template',
            downloadJsonTemplate: 'Download JSON Template',
            uploadTip: 'Drag the file here, or',
            clickUpload: 'click to upload',
            uploadNotice: 'Note: Please upload excel or json files to quickly create a project',
            searchProject: 'Search Project',
            search: 'Search',
            keepLogic: 'Keep Logic',
            keepScript: 'Keep Script',
            createTime: 'Created at: ',
            questionCount: 'Questions: ',
            aiPlaceholder: 'Please enter the description of the questionnaire you want to create, e.g.: Create a questionnaire about employee satisfaction, including questions on work environment, salary, career development, etc.',
            aiStart: 'Start Parsing',
            aiClear: 'Clear',
            aiTip1: 'AI will automatically generate the questionnaire structure based on your description',
            aiTip2: 'The more detailed the description, the more accurate the generated structure',
            info: 'Project Info',
            name: 'Project Name',
            namePlaceholder: 'Please enter the project name',
            nameRequired: 'Please enter project name',
            organization: 'Organization',
            organizationPlaceholder: 'Please enter the organization',
            description: 'Project Description',
            descriptionPlaceholder: 'Please enter the project description',
            cancel: 'Cancel',
            create: 'Create Project',
            uploadTemplate: 'Please upload a template file',
            selectCopyProject: 'Please select a project to copy',
            aiInputRequired: 'Please enter the AI parse description',
            aiParseRequired: 'Please run AI parse first',
            createSuccess: 'Project created successfully',
            createFail: 'Project creation failed',
            createFailRetry: 'Project creation failed, please try again later',
        },
    },
    recycle: {
        title: "Recycle Bin",
        id: "Project ID",
        name: "Project Name",
        deletedAt: "Deleted At",
        createdAt: "Created At",
        creator: "Creator",
        restore: "Restore",
        noData: "No Data",
        confirmDelete: "Confirm Delete",
        confirmDeleteTip: "Are you sure to permanently delete this project? This action cannot be undone.",
        restoreSuccess: "Restored successfully",
        restoreFail: "Restore failed",
        deleteSuccess: "Deleted successfully",
        deleteFail: "Delete failed"
    },
    user: {
        title: "User Management",
        id: "User ID",
        name: "Username",
        pageDesc: "Maintain account details and status. Assign specific permissions in Role Management.",
        account: "Account",
        fullname: "Full Name",
        noFullname: "No full name",
        mobile: "Mobile",
        email: "Email",
        avatar: "Avatar",
        avatarHint: "JPG / PNG, up to 2MB",
        sectionBasic: "Basic Info",
        emptyList: "No matching users. Try another keyword or reset the filters.",
        exportTodo: "Export has no backend endpoint yet and is unavailable.",
        ruleAccount: "Please enter the account",
        ruleAccountLen: "Account must be 2 to 32 characters",
        ruleMobile: "Please enter the mobile number",
        ruleMobileFormat: "Please enter a valid 11-digit mobile number",
        ruleEmail: "Please enter the email",
        ruleEmailFormat: "Please enter a valid email address",
        confirmDelete: "Are you sure to delete the user with ID \"{id}\"?",
        addTitle: "Add User",
        editTitle: "Edit User Info",
        uploadAvatar: "Change Avatar",
        uploadSuccess: "Upload successful!",
        uploadFail: "Upload failed: {msg}",
        uploadTypeError: "Avatar must be JPG/PNG format!",
        uploadSizeError: "Avatar size must not exceed 2MB!",
        placeholderName: "Please enter username",
        placeholderFullname: "Please enter full name",
        placeholderMobile: "Please enter mobile",
        placeholderEmail: "Please enter email",
        placeholderAvatar: "Please enter avatar URL"
    },
    role: {
        title: "Role Management",
        pageDesc: "A role is a set of menu permissions. Configure the menus here, then assign the role to users.",
        sectionBasic: "Basic Info",
        placeholderName: "Please enter the role name",
        placeholderKey: "Please enter the permission key",
        keyTip: "Identifier used by the backend to check permissions, e.g. admin, system:user",
        sortTip: "Smaller numbers come first",
        builtinTip: "Built-in role: cannot be disabled or deleted",
        emptyList: "No matching roles. Try another keyword or reset the filters.",
        ruleName: "Please enter the role name",
        ruleNameLen: "Role name must not exceed 30 characters",
        ruleKey: "Please enter the permission key",
        ruleKeyFormat: "Permission key may contain letters, digits, underscore and colon only",
        ruleSort: "Please enter the display order",
        id: "Role ID",
        name: "Role Name",
        key: "Permission Key",
        sort: "Order",
        status: "Status",
        createTime: "Created At",
        remark: "Remark",
        menuPerm: "Menu Permission",
        dataPerm: "Data Permission",
        assignUser: "Assign User",
        more: "More",
        confirmDelete: "Are you sure to delete the role with ID \"{id}\"?",
        addTitle: "Add Role",
        editTitle: "Edit Role",
        dataScope: "Data Scope",
        allData: "All Data Permission",
        customData: "Custom Data Permission",
        deptData: "Department Data Permission",
        deptBelowData: "Department and Below Data Permission",
        selfData: "Self Data Permission",
        selectAll: "Select All/Unselect All",
        parentLink: "Parent-Child Linkage",
        loading: "Loading, please wait",
        remarkPlaceholder: "Please enter content",
        successAdd: "Added successfully",
        successEdit: "Edited successfully",
        successDelete: "Deleted successfully",
        successStatus: "{action} succeeded",
        confirmStatus: "Are you sure to {action} the role \"{name}\"?",
        assignDataPerm: "Assign Data Permission",
        assignUserTitle: "Assign User",
        cancelAuth: "Cancel Authorization",
        batchCancelAuth: "Batch Cancel Authorization",
        closePage: "Close",
        selectUser: "Select User",
        selectUserTip: "Please select users to assign",
        selectUserSuccess: "Assigned successfully",
        cancelAuthSuccess: "Authorization removed",
        confirmCancelAuth: "Remove this role from user \"{name}\"?",
        confirmBatchCancelAuth: "Remove authorization for the selected users?",
        authUserSubtitle: "Manage users under this role: add more or remove authorization",
        currentRole: "Current role",
        authUserEmpty: "No users are authorized for this role yet. Click \"Add User\" to start.",
        selectUserEmpty: "No assignable users left, every user already has this role.",
        selectUserTitleTip: "Tick the users and confirm to grant them this role"
    },
    menu: {
        title: "Menu Management",
        pageDesc: "Each row is one sidebar entry. Directories only group items, menus map to pages, buttons only carry permission keys.",
        sectionBasic: "Basic Info",
        sectionRoute: "Route & Component",
        sectionPerm: "Permission & Status",
        shown: "Shown",
        hidden: "Hidden",
        addChild: "Add Child",
        addChildTip: "Add a child menu under this item",
        emptyFiltered: "No matching menu. Try another keyword or reset.",
        filteredCount: "{n} matched",
        hintDirectory: "Grouping only, no page behind it",
        hintMenu: "Maps to a real page, component path required",
        hintButton: "Not shown in the sidebar, only carries a permission key",
        confirmDeleteWithChildren: "\"{name}\" still has {n} child menus. Deleting it invalidates them too. Continue?",
        name: "Menu Name",
        icon: "Icon",
        sort: "Sort",
        perms: "Permission",
        component: "Component Path",
        status: "Status",
        createTime: "Created At",
        confirmDelete: "Are you sure to delete the menu named \"{name}\"?",
        addTitle: "Add Menu",
        editTitle: "Edit Menu",
        successAdd: "Added successfully",
        successEdit: "Edited successfully",
        successDelete: "Deleted successfully",
        placeholderName: "Please enter menu name",
        placeholderRouteName: "Please enter route name",
        placeholderPath: "Please enter route address",
        placeholderComponent: "Please enter component path",
        placeholderPerms: "Please enter permission identifier",
        placeholderQuery: "Please enter route parameters",
        placeholderIcon: "Click to select icon",
        placeholderParentMenu: "Select parent menu",
        parentMenu: "Parent Menu",
        menuType: "Menu Type",
        directory: "Directory",
        menu: "Menu",
        button: "Button",
        menuIcon: "Menu Icon",
        displaySort: "Display Order",
        routeName: "Route Name",
        routeNameTip: "If not filled, it will be the same as the route address: if the address is `user`, the name will be `User` (Note: To avoid name conflicts, please customize in special cases to ensure uniqueness)",
        isExternalLink: "Is External Link",
        externalLinkTip: "If external link is selected, the route address needs to start with `http(s)://`",
        routeAddress: "Route Address",
        routeAddressTip: "The route address to access, such as: `user`, if external address needs internal link access, start with `http(s)://`",
        componentPath: "Component Path",
        componentPathTip: "The component path to access, such as: `system/user/index`, default is under the `views` directory",
        permissionChar: "Permission Character",
        permissionCharTip: "Permission characters defined in the controller, such as: @PreAuthorize(`@ss.hasPermi('system:user:list')`)",
        routeParams: "Route Parameters",
        routeParamsTip: "Default parameters passed when accessing the route, such as: `{\"id\": 1, \"name\": \"ry\"}`",
        displayStatus: "Display Status",
        displayStatusTip: "If hidden is selected, the route will not appear in the sidebar, but can still be accessed",
        menuStatus: "Menu Status",
        menuStatusTip: "If disabled is selected, the route will not appear in the sidebar and cannot be accessed",
        yes: "Yes",
        no: "No",
        mainCategory: "Main Category",
        nameRequired: "Menu name cannot be empty",
        sortRequired: "Menu order cannot be empty",
        pathRequired: "Route address cannot be empty"
    },
    header: {
        lang: {
            zh: 'Simplified Chinese',
            zh_TW: 'Traditional Chinese',
            en: 'English',
            jp: 'Japanese',
            ko: 'Korean',
            id: 'Indonesian',
        },
        helpDoc: 'Help Doc'
    },
        questionEdit: {
        readonlyLocked: 'This project has view-only access. Content cannot be modified.',
        // Question Types
        sortQuestion: 'Sort Question',
        singleQuestion: 'Single Question',
        multiQuestion: 'Multiple Question',
        numberQuestion: 'Number Question',
        textQuestion: 'Text Question',
        textareaQuestion: 'Textarea Question',
        dateQuestion: 'Date Question',
        timeQuestion: 'Time Question',
        uploadQuestion: 'Upload Question',
        scoreQuestion: 'Score Question',
        scoreStyle: 'Rating Style',
        scoreStyleStar: 'Star',
        scoreStyleNumber: 'Number',
        scoreStyleEmoji: 'Emoji',
        scoreStyleSlider: 'Slider',
        scoreRange: 'Score Range',
        scorePointConfig: 'Score Point Config',
        scorePointConfigTip: 'Set score value, code, and label separately',
        scoreValueLabel: 'Score',
        scoreCodeLabel: 'Code',
        scoreTextLabel: 'Label',
        scoreTextPlaceholder: 'Enter the description for this score',
        titleSaveSuccess: 'Title saved successfully',
        ratingVeryPoor: 'Dissatisfied',
        ratingNormal: 'Average',
        ratingGood: 'Satisfied',
        openQuestion: 'Open Question',
        timestampQuestion: 'Timestamp',
        selectQuestion: 'Select Question',
        cascadeSettings: 'Cascade Settings',
        cascadeLevels: 'Cascade Levels',
        cascadeLevelLabel: 'Level {level} Options',
        cascadeOptionsManagement: 'Cascade Options Management',
        placeholderHint: 'Placeholder: ',
        placeholderInput: 'Please enter placeholder for level {level}',
        manageOptions: 'Manage Options',
        manageSubOptions: 'Manage Sub-options',
        subOptionNamePlaceholder: 'Please enter sub-option name',
        optionTextLabel: 'Option Text',
        optionCodeLabel: 'Option Code',
        optionTextPlaceholder: 'Please enter option text',
        optionCodePlaceholder: 'Please enter option code',
        optionCodeDuplicate: 'Duplicate option codes found at level {level}',
        optionCodeDuplicateGlobal: 'Duplicate option codes found. Please fix before saving',
        optionValueDuplicate: 'Option values cannot be duplicated in this question',
        publishOptionCodeDuplicate: 'Duplicate option codes found in: {questions}. Please fix before publishing',
        matrixSingleQuestion: 'Matrix Single Question',
        matrixMultiQuestion: 'Matrix Multiple Question',
        matrixBlankQuestion: 'Matrix Blank',
        matrixStatisticsQuestion: 'Matrix Statistics Question',
        matrixCompositionQuestion: 'Matrix Composition',
        combinationQuestion: 'Combination Question',
        thermodynamicChartQuestion: 'Thermodynamic Chart',
        projectLanguage: 'Project Language',
        autoRecordQuestion: 'Auto Record Question',
        maxDiffQuestion: 'MaxDiff Question',
        thermo: {
            changeImage: 'Change Image',
            showIndex: 'Show Index',
            maxClicks: 'Max Clicks',
            color: 'Color',
            size: 'Size',
            clearPoints: 'Clear Points',
            clickCount: 'Clicks: {count}',
            imageOnlyTip: 'Images only'
        },
        // Special Question Types
        specialComponents: 'Special Components',
        loopQuestion: 'Loop Question',

        // Common Actions
        delete: 'Delete',
        clear: 'Clear',
        addOption: 'Add Option',
        batchAdd: 'Batch Add',
        batchAddTitle: 'Batch Add Options',
        batchAddHint: 'One option per line. When pasting two columns from Excel, the numeric column is detected as the option value; without tabs, "1 option text" separated by spaces also works. The parsed result is previewed below and can be dragged into its final order.',
        batchAddPlaceholder: '1\tOption A\n2\tOption B\n3\tOption C',
        batchAddParsedCount: '{count} option(s) detected',
        batchAddPreviewTitle: 'Final order after adding',
        batchAddPreviewEmpty: 'Paste content to preview the complete option list after adding',
        batchAddTagNew: 'New',
        batchAddDragTip: 'Drag anywhere on the row to reorder; both value and option text are editable',
        batchAddValueTaken: 'Value {input} is already used by another option, changed to {value}',
        batchAddValueInvalid: 'Value {input} is not a valid positive integer, changed to {value}',
        batchAddValueAdjustedTip: '{count} option(s) had a duplicate or invalid value and were reassigned to unused values. Hover the amber icon on the row for the reason, or type the value you want.',
        batchAddRowErrorSummary: '{count} row(s) need fixing before you can confirm',
        batchAddRichHint: 'This option contains rich text; only plain text is shown here. Leave it unchanged to keep the original formatting',
        batchAddWhitespaceHint: 'This option text has leading/trailing spaces, which are kept and shown to respondents',
        batchAddModeTab: 'Split by tab',
        batchAddModeSpace: 'Split by space',
        batchAddModeTextOnly: 'Whole line as option text',
        batchAddSuccess: '{count} option(s) added',
        batchAddExistingCount: '{count} existing',
        batchAddRemoveExisting: 'Delete existing options',
        batchAddRemoveExistingHint: 'Remove all existing options at once, keeping only the ones pasted this time',
        batchAddRestoreRemoved: 'Restore {count}',
        batchAddRestoreRemovedHint: 'Put the options you just deleted back in their original positions',
        batchAddRemoveRowHint: 'Delete this row (existing options can be deleted too)',
        batchAddPreviewEmptyAfterRemove: 'All {count} existing option(s) removed. Paste new options to continue, or click Restore above to bring them back.',
        batchAddNeedOneOption: 'At least 1 option must remain in the preview',
        batchAddSuccessMixed: '{added} option(s) added, {removed} deleted',
        batchDelete: 'Batch Delete',
        batchSelectAll: 'Select All',
        batchSelectOption: 'Select this option',
        batchSelectedCount: '{count} selected',
        batchDeleteSelected: 'Delete Selected',
        batchDeleteConfirmMessage: 'Delete the {count} selected option(s)? You can restore them with Undo.',
        batchDeleteSuccess: '{count} option(s) deleted',
        batchSelectAllRows: 'Select all rows',
        batchSelectAllCols: 'Select all columns',
        batchSelectRow: 'Select this row',
        batchSelectColumn: 'Select this column',
        batchSelectedMatrixCount: '{rows} row(s) · {cols} column(s) selected',
        batchDeleteConfirmMatrix: 'Delete the selected {rows} row(s) and {cols} column(s)? You can restore them with Undo.',
        batchDeleteSuccessMatrix: '{rows} row(s) and {cols} column(s) deleted',
        clearConfirmCount: '{count} question(s) in total',
        loadingMoreQuestions: 'Loading more questions…',
        loadedProgress: '{loaded} of {total} questions loaded, click to load more',
        richText: 'Rich Text',
        confirm: 'Confirm',
        cancel: 'Cancel',

        // Placeholders
        optionPlaceholder: 'Please enter option',
        numberPlaceholder: 'Please enter a number',
        textPlaceholder: 'Please enter text',
        datePlaceholder: 'Please select date',
        timePlaceholder: 'Please select time',
        scorePlaceholder: 'Please rate',
        uploadPlaceholder: 'Click or drag file to upload',
        dateFormat: 'Date Time Format',
        searchPlaceholder: 'Search questions (title/no.)',
        quickJump: 'Quick Jump',
        searchAndJump: 'Search and select to jump',
        refreshOutline: 'Refresh Outline',
        order: 'Order',
        orderImportExport: 'Question No. Order Import/Export',

        // Additional keys for design/index.vue template
        inputQuestionNo: 'Input Question Number',
        scriptType: 'Script Type',
        tags: 'Tags',

        // Collect functionality
        collectQuestion: 'Collect Question',
        collectSuccess: 'Question collected successfully',
        collectFail: 'Collection failed',

        // Messages
        saveSuccess: 'Saved successfully',
        saveFail: 'Save failed',
        deleteSuccess: 'Deleted successfully',
        deleteFail: 'Delete failed',
        uploadSuccess: 'Upload successful',
        uploadFail: 'Upload failed',
        emptyOptionError: 'Option content cannot be empty',
        optionValueEmpty: 'Option value cannot be empty or 0',
        optionEmptyReverted: 'Option content was empty, so the previous text was restored. Use the delete button to remove it.',
        addQuestionSuccess: 'Question added',
        undo: 'Undo',
        undoSuccess: 'Last change undone',
        undoNoChange: 'Nothing to undo',
        undoFailed: 'Undo failed, please try again',
        switchLanguageSuccess: 'Switch language successfully',
        maxFilesExceeded: 'Maximum {max} files allowed',
        fileSizeExceeded: 'File size cannot exceed {size}MB',

        // Editing
        newOption: 'New Option',
        editTitle: 'Edit Title',
        editOption: 'Edit Option',
        deleteConfirm: 'Are you sure to delete?',
        titleMarkupLostTitle: 'Title contains formatting',
        titleMarkupLostMessage: 'This title contains rich-text formatting. Saving plain text will discard it. Continue? (You can also click "Rich Text" to keep the formatting.)',

        // Answer reference (insert an earlier answer into the title)
        answerRef: {
            button: 'Reference answer',
            buttonTip: 'Insert an earlier question\'s answer into the title',
            title: 'Reference an earlier answer',
            subtitle: 'Insert an earlier answer into the title. It will be replaced with the respondent\'s choice at run time.',
            search: 'Search by number or title…',
            empty: 'No earlier questions to reference',
            loading: 'Loading questions…',
            disabled: 'Not supported',
            disabledTip: 'This question type cannot be referenced yet',
            quickInsert: 'Insert',
            modes: 'Reference type',
            modeWhole: 'Whole answer',
            modeWholeDesc: 'Use the respondent\'s complete answer to this question',
            modeOther: '"Other" text',
            modeOtherDesc: 'Only use the text typed in "Other"',
            modeItem: 'Option {n}',
            modeRow: 'Row {n}',
            modeCell: 'Row {r}, column {c}',
            modeItemTitle: 'Nth selected option',
            modeItemDesc: 'Use the Nth option selected in a multiple-choice or ranking question',
            modeRowTitle: 'A row',
            modeRowDesc: 'Use the answer for this matrix row',
            modeCellTitle: 'A cell',
            modeCellDesc: 'Use the answer for this matrix cell',
            rowPick: 'Choose a row',
            cellPick: 'Click a cell in the table',
            otherPick: 'Choose which "Other"',
            itemPick: 'Choose the item number',
            preview: 'Example',
            previewPrefix: 'Preview: ',
            unanswered: 'If unanswered: {text}',
            unansweredSample: '[Not answered]',
            insert: 'Insert into title',
            cancel: 'Cancel',
            inserted: 'Referenced',
            dragHint: 'Drag a chip in the title to reposition it',
            broken: 'Reference is broken',
            removeRef: 'Remove this reference',
            brokenTip: 'This question was deleted or renumbered',
            noPreview: 'Select a question on the left to see options'
        },

        // Keyboard shortcuts help
        shortcutsEntry: 'Shortcuts',
        shortcutsTitle: 'Editing shortcuts',
        shortcutsTip: 'Question titles, options and matrix row/column headers are all editable in place with a single click. The shortcuts below apply while editing in place.',
        shortcutsGroupTitle: 'Question title',
        shortcutsGroupOption: 'Options (single / multiple / sort)',
        shortcutsGroupMatrix: 'Matrix rows and columns (all five matrix types)',
        shortcutsGroupBatch: 'Batch delete mode',
        shortcutClick: 'Click',
        shortcutTitleClick: 'Edit the question title in place',
        shortcutTitleEnter: 'Save the title and leave edit mode',
        shortcutTitleEsc: 'Discard this change',
        shortcutTitleRich: 'Click "Rich Text" next to the title for bold, images and other formatting',
        shortcutOptionClick: 'Edit the option in place',
        shortcutOptionEnter: 'Save and move to the next option',
        shortcutOptionShiftEnter: 'Save and create a new option below',
        shortcutOptionEsc: 'Discard this change',
        shortcutUndo: 'Undo the last step (title, option text, option delete, drag reorder, batch add/delete — up to 20 steps)',
        shortcutMatrixClick: 'Edit a row or column header in place',
        shortcutMatrixEnter: 'Save and move to the next row / column',
        shortcutMatrixShiftEnter: 'Save and add a new row / column',
        shortcutMatrixEsc: 'Discard this change',
        shortcutMatrixUndo: 'Undo the last row/column change',
        shortcutBatchEnter: 'Select / unselect the current option',
        shortcutBatchEsc: 'Leave batch delete mode',

        // Next question countdown
        nextWaitSeconds: 'Next question countdown (seconds)',
        nextWaitSecondsTip: '0 disables; counts after clicking Next',

        // Default Values
        defaultTitle: 'New Question',
        defaultOption: 'Option {index}',

        // ===== Additional keys for design/index.vue template, keep duplicates for later adjustment =====
        edit: 'Edit',
        save: 'Save',
        statistics: 'Statistics',
        data: 'Data',
        download: 'Download',
        publish: 'Publish',
        quotaLink: 'Quota Link',
        quotaLinkMissingConfig: 'External quota system URL is not configured',
        quotaLinkMissingSurveyId: 'Survey ID is missing',
        projectFile: 'Project File',
        projectFileView: {
            exportTitle: 'Export Project',
            importTitle: 'Import Project',
            exportJson: 'Export JSON',
            exportExcel: 'Export EXCEL',
            preview: 'Preview',
            hidePreview: 'Hide Preview',
            questionNo: 'Question No',
            questionText: 'Question Text',
            questionType: 'Question Type',
            manualImport: 'Manual Import',
            fileLabel: 'File: ',
            questionCountLabel: 'Questions: {count}',
            dropTitle: 'Drag JSON or Excel file here',
            dropSubtitle: 'Or click this area/"Manual Import" to select files',
            dropTip: 'Supported: .json, .xlsx, .xls',
            selectAllLabel: 'Select All ({selected}/{total})',
            confirmImport: 'Confirm Import',
            importing: 'Importing...',
            clear: 'Clear',
            close: 'Close',
            exportSuccess: 'Export succeeded',
            exportFail: 'Export failed',
            projectIdRequired: 'Project ID is missing',
            noPreviewQuestions: 'No questions to preview',
            importSuccess: 'Import completed',
            importFail: 'Import failed',
            noQuestionsSelected: 'No questions selected',
            importNoQuestionsParsed: 'No questions parsed, please check Excel template',
            excelParseFailWithMsg: 'Excel parse failed: {msg}',
            duplicateQuestionNos: 'Excel validation failed: duplicate question numbers. Details: {details}',
            unsupportedFileType: 'Unsupported file type, please select JSON or Excel',
            fileNoQuestionsData: 'No question data found in the file',
            jsonParseFail: 'Parse failed: Invalid JSON file format'
        },
        projectLanguage: 'Project Language',
        importQuestions: 'Import Questions',
        exportGuid: 'Export GUID',
        exportGuidLoading: 'Exporting GUID. Large data volume, please wait...',
        exportGuidSuccess: 'GUID export succeeded',
        exportGuidFail: 'GUID export failed: {msg}',
        questionType: 'Question Type',
        outline: 'Outline',
        aiTools: 'AI funtion',
        previewDialog: {
            title: 'Question Preview',
            projectId: 'Project ID: ',
            questionNo: 'Question No: ',
            refresh: 'Refresh Preview',
            loading: 'Loading...',
            empty: 'No preview content',
            projectOrQuestionIdMissing: 'Missing project or question ID',
            notHtml: 'API did not return HTML content',
            fetchFail: 'Failed to fetch preview',
            fetchFailRetry: 'Failed to fetch preview, please try later',
            devicePhone: 'Phone',
            deviceTablet: 'Tablet',
            devicePc: 'PC'
        },
        questionBank: {
            // title: 'Question Bank',
            searchPlaceholder: 'Search question',
            myBank: 'My Question Bank',
            publicBank: 'Public Question Bank',
            add: 'Add',
            type: 'Type',
            category: 'Category',
            title: 'Title',
            options: 'Options',
            unnamedOption: 'Unnamed Option',
            noOptions: 'No options',
            close: 'Close',
            addToForm: 'Add to Form',
            collect: 'Collect',
            addedToFormSuccess: 'Question added to form',
            addFail: 'Add failed',
            collectSuccess: 'Collected successfully',
            collectFail: 'Collect failed',
        },
        basicComponents: 'Basic Components',
        advancedComponents: 'Advanced Components',
        myQuestionBank: 'My Question Bank',
        add: 'Add',
        comprehensiveCustomerSatisfactionSurvey: 'Comprehensive Customer Satisfaction Survey',
        publicQuestionBank: 'Public Question Bank',
        standardQuestionBankGroup: 'Standard Question Bank Group',
        standardTextQuestion: 'Standard Text Question',
        standardSingleChoiceQuestion: 'Standard Single Choice Question',
        standardMultipleChoiceQuestion: 'Standard Multiple Choice Question',
        standardOpenQuestion: 'Standard Open Question',
        standardRatingQuestion: 'Standard Rating Question',
        specialQuestionBankGroup: 'Special Question Bank Group',
        specialTextQuestion: 'Special Text Question',
        otherQuestionBankGroup: 'Other Question Bank Group',
        set: 'Set',
        thenExecutionActions: 'THEN Execution Actions',
        beforeExecution: 'Before Execution',
        duringExecution: 'During Execution',
        afterExecution: 'After Execution',
        favoriteScript: 'Favorite Script',
        personal: 'Personal',
        details: 'Details',
        tabSetting: 'Setting',
        tabLogic: 'Logic',
        tabScript: 'Script',
        options: 'Options',
        moreConfig: 'More Config',
        lengthPx: 'Length (px):',
        widthPercent: 'Width (%):',
        minLength: 'Min Length:',
        maxLength: 'Max Length:',
        minNumber: 'Min Number:',
        maxNumber: 'Max Number:',
        allowChar: 'Character:',
    allowNumber: 'Number:',
    allowDecimal: 'Decimal:',
    decimalPlaces: 'Decimal Places:',
        fontSelect: 'Font Select',
        fontSize: 'Font Size',
        optionSize: 'Option Size',
        layoutDirection: 'Layout Direction',
        horizontal: 'Horizontal',
        vertical: 'Vertical',
        rowCount: 'Row Count',
        rowWidth: 'Row Width',
        colCount: 'Column Count',
        colHeight: 'Column Height',
        hideImage: 'Hide Image',
        operate: 'Operate',
        saveLogic: 'Save Logic',
        logicList: 'Logic List',
        selectCondition: 'Select Condition',
        selectOption: 'Select Option',
        inputValue: 'Please enter value',
        selectRelation: 'Select Relation',
        priority: 'Priority',
        selectAction: 'Select Action',
        inputText: 'Please enter text',
        inputLink: 'Please enter link',
        inputQuestionTitle: 'Please enter new question title',
        selectRowCol: 'Select Row/Col',
        row: 'Row',
        column: 'Column',
        selectRowOption: 'Select Row Option',
        selectColOption: 'Select Column Option',
        conditions: {
            true: 'true',
            equal: 'equal',
            notEqual: 'notEqual',
            contain: 'contain',
            NContain: 'NContain',
            isBlank: 'isBlank',
            isNBlank: 'isNBlank',
            countLT: 'countLT',
            countGT: 'countGT',
            countEQ: 'countEQ',
            countNE: 'countNE',
            countGE: 'countGE',
            countLE: 'countLE',
            countVLT: 'countVLT',
            countVGT: 'countVGT',
            countVEQ: 'countVEQ',
            countVGE: 'countVGE',
            countVLE: 'countVLE'
        },
        actions: {
            thisValues: 'thisValues',
            thisShowOptions: 'thisShowOptions',
            thisRandom: 'thisRandom',
            thisHide: 'thisHide',
            thisMatchShow: 'thisMatchShow',
            thisDifferentShow: 'thisDifferentShow',
            thisSingle: 'thisSingle',
            thisAutoRecord: 'thisAutoRecord',
            thisAutoRecVal: 'thisAutoRecVal',
            thisFixShow: 'thisFixShow',
            thisRandom_v2: 'thisRandom_v2',
            thisHide_v2: 'thisHide_v2',
            goto: 'goto',
            gotoLink: 'gotoLink',
            gotoNQ: 'gotoNQ',
            goBack: 'goBack',
            close: 'close',
            screenClose: 'screenClose',
            alert: 'alert',
            confirm: 'confirm',
            skipThis: 'skipThis',
            notSkip: 'notSkip',
            canBlank: 'canBlank',
            otherBlank: 'otherBlank',
            lock: 'lock',
            unlock: 'unlock',
            setQuestionTitle: 'setQuestionTitle'
        },
        connectors: {
            ifPrefix: 'If ',
            thenPrefix: 'Then ',
            andConnector: ' And '
        },
        logic: {
            and: 'And',
            or: 'Or',
            end: 'End'
        },
        searchScript: 'Search Script',
        detail: 'Detail',
        scriptEdit: 'Script Edit',
        scriptDetail: 'Script Detail',
        search: 'Search',
        questionNo: 'Question No',
        logicSettings: 'Logic Settings',
        refreshLogic: 'Refresh Logic',
        addLogic: 'Add Logic',
        ifConditionSettings: 'IF Condition Settings',
        favoriteScriptList: 'Favorite Script List',
        public: 'Public',
        apply: 'Apply',
        saveScript: 'Save Script',
        optionContent: 'Option Content',
        tabMoreSetting: 'Setting',
        tabMoreDisplay: 'Display',
        tabMoreImage: 'Image',
        saveSuccess: 'Saved successfully',
        saveFailed: 'Save failed',
        fontMicrosoftYaHei: 'Microsoft YaHei',
        fontSimSun: 'SimSun',
        fontSimHei: 'SimHei',
        fontArial: 'Arial',
        ai: {
            codingButton: 'AI coding',
            tableButton: 'AI Table',
            reportTitle: 'AI report',
            notOpen: 'Not available yet'
        },
        addOther: 'Add Other',
        addNoneOfAbove: 'Add "None of the above"',
        noneOfAbove: 'None of the above',
        exclusiveTag: 'Single',
        exclusiveTagTip: 'Single-select: choosing this clears all other options',
        exclusiveRemoveTip: 'Click to remove the rule',
        exclusiveExists: 'Single-select logic already exists',
        exclusiveRemoveConfirm: 'This will remove the "single-select" logic. Continue?',
        exclusiveRemoved: 'Single-select logic removed',
        exclusiveAdded: 'Single-select logic added',
        exclusiveLogicSaveFailed: 'Failed to save the single-select logic. Please add it manually in the Logic tab.',
        netGroup: 'NET Group',
        netGroupPlaceholder: 'Enter group name',
        netLabel: 'Group:',
        netNone: '-',
        otherOptionLabel: 'Other Option:',
        otherInputPlaceholder: 'Please enter other text',
        actionNotAllowedSameQuestion: 'Option assignment cannot target the same question as IF conditions',
        actionThisSingleRequiresMultiple: '"thisSingle" only applies to multiple-choice questions. Please select MULTIPLE.',
        // Design page i18n additions
        totalQuestions: 'Total {count} questions',
        clearAll: 'Clear All',
        clearAllTitle: 'Clear all questions',
        collapse: 'Collapse',
        expand: 'Expand',
        unnamedQuestion: '(Untitled question)',
        clearConfirmTitle: 'Confirm Clear',
        clearConfirmMessage: 'Are you sure to clear all questions? This cannot be undone.',
        clearedMessage: 'All questions have been cleared',
        clearPartialFailed: 'Some questions failed to delete. Please refresh.',
        clearFailedMessage: 'Clear failed: {msg}',
        valueLabel: 'Value:',
        otherLabel: 'Other:',
        other: 'Other',
        isOther: 'Is Other',
        deleteConfirmTitle: 'Delete Confirmation',
        deleteConfirmMessageOption: 'Confirm deleting this option? Label: {label}, Code: {code}',
        optionDeleted: 'Option deleted',
        deleteConfirmMessageQuestion: 'Confirm deleting this question? No.: {no}, Title: {title}',
        questionDeleted: 'Question deleted',
        Statistics: {
            version: 'Version',
            versionPlaceholder: 'Enter numeric version',
            versionTooltip: 'Numbers only, e.g., 1, 2, 3',
            linkType: 'Link Type',
            linkTypeAll: 'All',
            linkTypeTest: 'Test Link',
            linkTypeProd1: 'Official Link 1',
            linkTypeProd2: 'Official Link 2',
            linkTypeOffline: 'Offline Version',
            linkTypeCustom: 'Custom',
            dateRange: 'Date Range',
            filter: 'Filter',
            dashboardTitle: 'Data Analysis Dashboard',
            effectiveCount: 'Valid Responses',
            totalCount: 'Total Surveys',
            recoveryRate: 'Recovery Rate',
            avgTime: 'Average Completion Time',
            deviceModel: 'Device Model',
            dailyTrend: 'Daily Collection Trend',
            respondentLocation: 'Respondent Location Distribution',
            briefRecordList: 'Brief Record List',
            projectId: 'Project ID',
            ipAddress: 'IP Address',
            deviceType: 'Device Type',
            time: 'Time',
            duration: 'Duration',
            singleChoiceTitle: 'Single Choice Answer Distribution',
            singleChoiceOption: 'Option Distribution',
            multipleChoiceTitle: 'Multiple Choice Answer Distribution',
            multipleChoicePeople: 'Number of Selections',
            optionA: 'Option A',
            optionB: 'Option B',
            optionC: 'Option C',
            optionD: 'Option D',
            china: 'China',
            usa: 'USA',
            europe: 'Europe',
            asiaOther: 'Other Asia',
            other: 'Other',
            ios: 'iOS',
            android: 'Android',
            pc: 'PC',
            windows: 'Windows',
            mac: 'Mac',
        },
        maxdiff: {
            mostImportant: 'Most Important',
            leastImportant: 'Least Important',
            mostLabel: 'Most Important Label',
            leastLabel: 'Least Important Label',
            instruction: 'Please select the most and least important attributes',
            instructionLabel: 'Instruction Text',
            instructionHint: 'Shown at the title of the task preview',
            alignment: 'Alignment',
            alignCenter: 'Center',
            alignLeft: 'Left',
            attributesPerTask: 'Attributes per task',
            attributesPerTaskHint: 'Range 3–{max}, not exceeding attributes (current {count})',
            totalTasks: 'Total tasks',
            totalTasksHint: 'Up to {max} tasks can be generated',
            taskPreview: 'Task Preview',
            prev: 'Previous',
            next: 'Next'
        },
        matrix: {
            functionA: 'Function A',
            functionB: 'Function B',
            functionC: 'Function C',
            projectA: 'Project A',
            projectB: 'Project B',
            projectC: 'Project C',
            satisfied: 'Satisfied',
            average: 'Average',
            dissatisfied: 'Dissatisfied',
            evaluate: 'Evaluation',
            suggestion: 'Suggestion',
            remark: 'Remark',
            enterEvaluate: 'Please enter evaluation',
            enterSuggestion: 'Please enter suggestion',
            enterRemark: 'Please enter remark',
            firstQuarter: 'Q1',
            secondQuarter: 'Q2',
            thirdQuarter: 'Q3',
            fourthQuarter: 'Q4',
            enterValue: 'Please enter a number',
            score: 'Score',
            select: 'Select',
            exportOrientation: 'Orientation',
            perRow: 'Row',
            perCol: 'Column',
            exclusiveLabel: 'None of the above',
            exclusiveNone: 'Off',
            exclusiveRow: 'Row only',
            exclusiveCol: 'Column only',
            exclusiveBoth: 'Row + column',
            transposeStructure: 'Transpose structure',
            total: 'Total'
        },
        matrixComposition: {
            // Button texts
            addColumn: 'Add Column',
            addRow: 'Add Row',
            swapRowsAndColumns: 'Transpose',
            deleteRow: 'Delete',
            // Dialog titles
            editRow: 'Edit Row',
            addRowDialog: 'Add Row',
            editColumn: 'Edit Column',
            addColumnDialog: 'Add Column',
            // Form labels
            rowText: 'Row Text',
            columnText: 'Column Text',
            columnCode: 'Column Code',
            columnType: 'Column Type',
            required: 'Required',
            requiredWhen: 'Conditional Required',
            optionSettings: 'Option Settings',
            // Column type options
            radio: 'Single Choice',
            checkbox: 'Multiple Choice',
            input: 'Text Input',
            select: 'Dropdown',
            // Conditional required related
            dependencyLogic: 'Dependency Logic',
            dependencyColumns: 'Dependency Columns',
            anyColumnHasValue: 'Any column has value',
            allColumnsHaveValue: 'All columns have value',
            // Hint messages
            requiredWhenHint: 'This column is required only when dependency columns meet conditions',
            requiredHint: 'Note: When there are no multiple-choice columns, this setting is invalid and will be validated as "at least one item per row"',
            finalCode: 'Final Code',
            // Suffix related
            suffixPlaceholder: 'Enter unit',
            suffixDisplay: 'Enter unit',
            // Success messages
            rowSwapSuccess: 'Rows swapped successfully',
            columnSwapSuccess: 'Columns swapped successfully',
            rowColumnSwapSuccess: 'Row and column swapped successfully',
            columnRowSwapSuccess: 'Column and row swapped successfully',
            transposeSuccess: 'Transpose successful',
            // Confirmation dialogs
            confirmSwap: 'Swap this row with target column?',
            confirmColumnToRow: 'Swap this column with target row?',
            confirmTranspose: 'Transpose rows and columns? This will swap all rows and columns.',
            // Validation messages
            enterRowText: 'Please enter row text',
            enterColumnText: 'Please enter column text',
            enterColumnCode: 'Please enter column code',
            columnCodeExists: 'Column code already exists, please use another code',
            selectAtLeastOneOption: 'Dropdown column requires at least one option',
            // Required mark
            requiredMark: 'Required',
            // Conditional required tooltip
            conditionalRequired: 'Conditional Required',
            conditionalRequiredText: 'Required when {logic} columns 【{columns}】 have values',
            anyLogic: 'Any',
            allLogic: 'All'
        },
        dataView: {
            listTitle: 'Answer Records',
            id: 'ID',
            projectId: 'Project ID',
            version: 'Version',
            linkType: 'Link Type',
            status: 'Status',
            startTime: 'Answer Start Time',
            endTime: 'Answer End Time',
            createTime: 'Answer End Time',
            duration: 'Answer Duration',
            ipAddress: 'IP Address',
            deviceType: 'Device Model',
            device: 'Specific Device',
            actions: 'Actions',
            edit: 'Edit',
            details: 'Details',
            editAnswer: 'Edit Answer',
            cancel: 'Cancel',
            save: 'Save',
            refresh: 'Refresh Data',
            pageTotal: 'Total {total}',
            loading: 'Loading...',
            noRecords: 'No answer records yet',
            audioList: 'Audio List',
            notify: {
                filterApplied: 'Filters applied',
                filterReset: 'Filters reset',
                questionFilterApplied: 'Question filter applied',
                questionFilterReset: 'Question filter reset',
                noRecordsMatched: 'No records match the filters',
                loadSuccess: 'Loaded {count} records',
                fetchFail: 'Failed to fetch records, please check the network connection',
                networkRetryText: 'Network error, retry?',
                retry: 'Retry'
            }
        },
        downloadView: {
            title: 'Data Download',
            subtitle: 'Select file format and download options',
            exportOptions: 'Export Options',
            exportOptionsSubtitle: 'Select export format and options',
            fileFormat: 'File Format',
            exportOptionsTitle: 'Export Options',
            dateRange: 'Date Range',
            startDatePlaceholder: 'Start Date',
            endDatePlaceholder: 'End Date',
            startExport: 'Start Export',
            excel: 'Excel',
            excelDesc: 'Suitable for data analysis and processing',
            csv: 'CSV',
            csvDesc: 'Universal format, supported on all devices',
            pdf: 'PDF',
            pdfDesc: 'Good for printing and sharing',
            json: 'JSON',
            jsonDesc: 'For developers and system integration',
            spss: 'SPSS',
            spssDesc: 'For statistical analysis software',
            includeAnswerTime: 'Include answer time',
            includeDeviceInfo: 'Include device information',
            includeIpAddress: 'Include IP address',
            includeLocation: 'Include location',
            includeUserId: 'Include user identifier',
            includeAnswerType: 'Include answer type',
            includeQuestionAnswers: 'Include question answers',
            exportImageAnswer: 'Export image answers',
            // DownloadView page filters
            surveyStatus: 'Survey Status',
            statusAll: 'All',
            statusAnswered: 'Completed',
            compositeSplit: 'Composite Split',
            dataMode: 'Data Mode',
            durationUnit: 'Duration Unit',
            durationSecond: 'Seconds',
            durationMinute: 'Minutes',
            durationHms: 'hh:mm:ss',
            stripRichText: 'Rich Text',
            code: 'Code',
            label: 'Label',
            comingSoon: 'Feature under development, stay tuned',
            exportFail: 'Export failed',
            spssExportTypeError: 'SPSS export failed (unexpected return type)',
            spssExportEmptyFile: 'SPSS export failed (empty file)',
            spssExportFail: 'SPSS export failed',
            audio: 'Audio',
            audioDesc: 'Batch download all recording files',
            image: 'Images',
            imageDesc: 'Batch download all upload question files',
            language: 'Language',
            languageDefault: 'Default (none)',
        },
        publishProject: {
            title: 'Publish Project',
            historyLink: 'History Links',
            generateLink: 'Generate Link',
            moreLinks: 'More Links',
            downloadLink: 'Download Link',
            format: 'Format',
            linkGenerator: 'Survey Link Generator',
            fixedLink: 'Fixed Link Generation',
            prod1: 'Official Link 1',
            prod1Tip: 'With GUID and IP control',
            prod2: 'Official Link',
            prod2Tip: 'For official distribution; enables survey ID and resume support',
            test: 'Test Link',
            testTip: 'With navigation bar, show previous question button',
            ipCtrlDeveloping: 'IP control is still under development',
            breakpointAutoCheckedTip: 'When {source} is enabled, answer breakpoint control will be checked automatically',
            breakpointControlledTip: 'Answer breakpoint control cannot be checked directly. Please enable GUID control or survey ID first',
            offline: 'Offline Link',
            offlineTip: 'Offline link',
            custom: 'Custom Link',
            customTip: 'Custom link',
            customLink: 'Custom Link Generation',
            accessControl: 'Access Control',
            ipCtrl: 'IP Control',
            guidCtrl: 'GUID Control',
            surveyIdCtrl: 'Survey ID Enabled',
            collaborationCtrl: 'Collaboration Mode',
            breakpointCtrl: 'Answer Breakpoint Control',
            externalIdCtrl: 'External ID Breakpoint',
            questionnaireIdMode: 'Survey ID Mode',
            questionnaireIdModeDigits: 'Digits only',
            questionnaireIdModeSymbolPlusDigits: 'Letter + digits',
            questionnaireIdLength: 'Digits length',
            displayOptions: 'Display Options',
            showNav: 'Show Navigation Bar',
            showPrev: 'Show Previous Question Button',
            offlineSubmit: 'Offline link prevents duplicate submission',
            record: 'Enable Recording',
            fixedOption: 'Fixed Link',
            fixedOptionLockedTip: 'Fixed link is required for publishing and cannot be disabled',
            clearOldData: 'Clear Old Data',
            createLink: 'Create Link',
            generatedLink: 'Generated Link',
            placeholder: 'Please click Create Link first',
            copy: 'Copy',
            open: 'Open',
            copySuccess: 'Link copied to clipboard',
            generateSuccess: 'Link generated successfully!',
            generateFail: 'Generation failed',
            downloadPlaceholder: 'Click to generate download link',
            externalDownloadTitle: 'External Download Link',
            externalDownloadPlaceholder: 'External Download Link',
            surveyStatus: 'Survey Status',
            answered: 'Answered',
            downloadDataMode: 'Data Mode',
            label: 'Label',
            code: 'Code',
            compositeSplit: 'Composite Split',
            language: 'Language',
            durationUnit: 'Duration Unit',
            durationSecond: 'Seconds',
            durationMinute: 'Minutes',
            durationHms: 'hh:mm:ss',
            stripRichText: 'Strip rich text',
            languageDefault: 'Default (none)',
            toggleOn: 'Enable',
            history: 'History Links',
            all: 'All',
            prod: 'Official',
            testCategory: 'Test',
            id: 'ID',
            link: 'Link',
            category: 'Category',
            type: 'Type',
            createTime: 'Created At',
            disabled: 'Disabled',
            yes: 'Yes',
            no: 'No',
            version: 'Version',
            tags: 'Tags',
            // Block publish when status finished
            finishBlockedTitle: 'Cannot Publish',
            finishBlockedMessage: 'Survey has ended. Adjust status to publish.',
            finishBlockedButton: 'Got it',
            pausedBlockedTitle: 'Unable to publish',
            pausedBlockedMessage: 'Survey is paused. Set it back to Running before publishing.',
            pausedBlockedButton: 'Got it',
            clearConfirmTitle: 'Confirm Clear Data',
            clearConfirmMessage: 'This will clear historical responses before publishing. Continue?',
            clearConfirmOk: 'Continue',
            clearConfirmCancel: 'Cancel Clear',
            theme: 'Theme',
            themeDefault: 'Default',
            themeLuxury: 'Luxury',
            quotaOptions: 'Quota Options',
            quotaAll: 'All Quotas',
            quotaHidden: 'Hidden Quotas',
            quotaType: 'Type',
            quotaHiddenRatio: 'Hidden Ratio',
            quotaHiddenRatioPlaceholder: 'Enter hidden ratio',
            quotaHiddenRatioInvalid: 'Hidden ratio must be numeric and between 1 and 100',
            panelAll: 'All',
            confirmQuotaParams: 'Confirm Params',
            quotaPanelRequired: 'Please select a panel',
            quotaModeRequired: 'Please select a quota mode',
            quotaNeedConfirm: 'Please confirm parameters before opening external link',
            quotaModeEmpty: 'Failed to generate quota parameters',
            quotaConfirmSuccess: 'Quota parameters confirmed',
            quotaConfirmFail: 'Failed to confirm quota parameters',
            externalQuotaTitle: 'External Quota Link',
            externalQuotaPlaceholder: 'Select quota parameters'
        },
        resourceManagement: {
            resourceManagement: 'Resource Management',
            title: 'Resource Management',
            upload: 'Upload Resource',
            searchPlaceholder: 'Search Resource',
            id: 'ID',
            name: 'Resource Name',
            projectId: 'Project ID',
            createTime: 'Created At',
            url: 'Resource Link',
            actions: 'Actions',
            copyLink: 'Copy Link',
            delete: 'Delete',
            confirmDelete: 'Are you sure you want to delete this resource?',
            confirm: 'Confirm',
            deleteSuccess: 'Deleted successfully',
            deleteFail: 'Delete failed',
            copySuccess: 'Link copied to clipboard',
            fetchFail: 'Failed to fetch resource list',
            pageTotal: 'Total {total}',
        },
        resourceUpload: {
            title: 'Upload Resource',
            name: 'Resource Name',
            namePlaceholder: 'Please enter resource name',
            file: 'Resource Attachment',
            uploadText: 'Drag files here, or',
            clickUpload: 'click to upload',
            uploadTip: 'Note: Max size 100MB (supports jpg, png, pdf, doc, docx, xls, xlsx)',
            cancel: 'Cancel',
            confirm: 'Confirm',
            fileTypeError: 'File type not supported',
            fileSizeError: 'File size cannot exceed 100MB',
            nameRequired: 'Please enter resource name',
            fileRequired: 'Please select files to upload',
            uploadSuccess: 'Upload successful',
            uploadFail: 'Upload failed',
            deleteFail: 'Failed to delete resource, please try again',
        },
        autoRecord: {
            notFoundSourceOptions: 'No source question options found; cannot generate mapping',
            addedMappings: 'Added {count} mappings',
            copySuccess: 'Mapping JSON copied to clipboard',
            exportFail: 'Export failed',
            importTitle: 'Import Mapping',
            importConfirm: 'Import',
            importPlaceholder: 'Paste mapping JSON array or CSV (key,value)',
            importInputPlaceholder: '[{"key":"A","value":"Beijing"}] or\nA,Beijing',
            importSuccess: 'Imported {count} items (deduped {merged})',
            importFormatError: 'Import failed: invalid format',
            missingQuestionId: 'Missing question ID; cannot save',
            needOneSource: 'Please select at least one source question',
            selfReferenceError: 'Source question cannot be the current question',
            circularDependencyError: 'Detected circular dependency; blocked save',
            duplicateKey: 'Duplicate mapping key: {key}',
            formulaRequired: 'When calculation enabled, formula is required'
        },
        projectLanguageView: {
            title: 'Project Language Management',
            projectId: 'Project ID: {id}',
            exportBtn: 'Export Language File',
            exportDesc: 'Export current survey language template (Excel)',
            uploadBtn: 'Upload Language File',
            uploadDesc: 'Upload language file to update survey translation',
            close: 'Close',
            projectIdRequired: 'Project ID is required',
            exportSuccess: 'Language file exported successfully',
            exportFail: 'Export failed: {msg}',
            uploadTypeError: 'Only Excel files are allowed',
            uploadSizeError: 'File size must not exceed 10MB',
            uploadSuccess: 'Language file imported successfully',
            uploadFail: 'Import failed, please retry'
        },
        thirdPartyConfigView: {
            title: 'Project Panel Configuration',
            enableLabel: 'Enable',
            open: 'Open',
            close: 'Close',
            addPanel: 'Add Panel',
            loading: 'Loading panel list...',
            empty: 'No panel configuration yet',
            emptyHint: 'Click the top-right button to add the first panel'
        },
        thirdPartyConfig: {
            typeSelection: {
                title: 'Select Configuration Type',
                defaultTitle: 'Default Third-Party Config',
                defaultDesc: 'Configure third-party links and callback params',
                emailTitle: 'Third-Party Email Sending',
                emailDesc: 'Configure email sending and respondent management',
                confirm: 'Confirm Selection',
                back: 'Back to Type Selection'
            },
            steps: {
                emailConfig: 'Email Config',
                uploadRespondents: 'Upload Respondents',
                thirdpartyConfig: 'Third-Party Config'
            },
            data: {
                title: 'Data Management',
                downloadTemplate: 'Download Template',
                uploadData: 'Upload Data',
                uploading: 'Uploading...',
                clearData: 'Clear Data',
                searchPlaceholder: 'Enter email address to search',
                table: {
                    guid: 'GUID',
                    email: 'Email',
                    subject: 'Mail Subject',
                    content: 'Mail Content',
                    country: 'Country',
                    firstTime: 'First Time',
                    lastTime: 'Last Time',
                    total: 'Total',
                    status: 'Status',
                    statusDesc: 'Status Desc'
                }
            },
            email: {
                title: 'Email Config',
                panelName: 'Panel Name',
                panelNamePlaceholder: 'Enter panel name',
                emailAddress: 'Email Address',
                emailPlaceholder: 'admin@example.com',
                smtpServer: 'SMTP Server',
                smtpPlaceholder: 'smtp.qq.com',
                password: 'Password/Token',
                passwordPlaceholder: '••••',
                port: 'Port',
                save: 'Save Email Config'
            },
            thirdparty: {
                title: 'Third-Party Config',
                panelName: 'Panel Name',
                panelNamePlaceholder: 'Enter panel name',
                links: 'Links',
                linksPlaceholder: 'survey.test1.com;survey.test2.com',
                callback: 'Callback',
                mappingTitle: 'Parameter Mapping',
                addMapping: 'Add Mapping',
                paramKeyPlaceholder: 'Param Name (e.g., a)',
                paramValuePlaceholder: 'Mapping Value (e.g., uid)',
                emptyMapping: 'No mappings yet, click above to add',
                status: 'Status',
                statusPlaceholder: 's',
                complete: 'Complete',
                completeUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=1',
                screen: 'Screen',
                screenUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=2',
                quota: 'Quota',
                quotaUrlPlaceholder: 'survey.test.com/survey/survey/back.do?status=3',
                flexible: 'Flexible Redirect',
                flexibleTip: 'When enabled, redirect to the return URL carried by the link; the three callback fields will be hidden',
                save: 'Save Third-Party Config'
            },
            validation: {
                email: {
                    nameRequired: 'Please enter panel name',
                    nameLength: 'Length must be between 1 and 50 characters',
                    emailRequired: 'Please enter email address',
                    emailInvalid: 'Please enter a valid email address',
                    smtpRequired: 'Please enter SMTP server address',
                    passwordRequired: 'Please enter password or token',
                    portRequired: 'Please enter port',
                    portRange: 'Port must be within 1-65535'
                },
                thirdparty: {
                    nameRequired: 'Please enter panel name',
                    linksRequired: 'Please enter links',
                    mappingRequired: 'Please add at least one parameter mapping',
                    mappingIncomplete: 'Please complete param name and mapping value for all mappings',
                    statusRequired: 'Please enter status identifier',
                    completeUrlRequired: 'Please enter complete callback URL',
                    screenUrlRequired: 'Please enter screen callback URL',
                    quotaUrlRequired: 'Please enter quota callback URL'
                }
            },
            notify: {
                fetchPanelListFail: 'Failed to load panel list',
                panelOpened: 'Panel enabled',
                panelClosed: 'Panel disabled',
                updatePanelStatusFail: 'Failed to update panel enable status',
                getPanelDetailFail: 'Failed to get panel details',
                deletePanelSuccess: 'Deleted successfully',
                deletePanelFail: 'Delete failed',
                emailUpdateSuccess: 'Email config updated',
                emailCreateSuccess: 'Email config created',
                emailSaveFail: 'Failed to save email config',
                thirdpartyUpdateSuccess: 'Third-party config updated',
                thirdpartyCreateSuccess: 'Third-party config created',
                thirdpartySaveFail: 'Failed to save third-party config',
                allUpdateSuccess: 'Config updated',
                allCreateSuccess: 'Config created',
                allSaveFail: 'Failed to save config',
                completeAllSteps: 'Configuration completed! All steps finished.',
                templateDownloadSuccess: 'Template downloaded',
                templateDownloadFail: 'Template download failed',
                searchFail: 'Search failed',
                uploadFileTypeError: 'Only Excel files are allowed!',
                uploadFileSizeError: 'File size must be under 10MB!',
                uploadFileSuccess: 'File uploaded!',
                uploadFileFail: 'File upload failed, please retry',
                uploadDataAllDone: 'Data upload completed, all configurations finished! You may close this dialog.',
                clearDataSuccess: 'Data cleared',
                clearDataFail: 'Failed to clear data',
                saveDataConfigSuccess: 'Data configuration saved',
                saveDataConfigFail: 'Failed to save data configuration'
            },
            nav: {
                prev: 'Previous',
                next: 'Next',
                complete: 'Complete'
            }
        },
        changeType: 'Change Type',
        copyOptions: {
            title: 'Copy Options',
            currentQuestion: 'Current Question',
            sourceQuestion: 'Source Question',
            sourcePlaceholder: 'Select source question',
            rulesTitle: 'Option Copy Rules',
            ruleSingleMultiSort: 'Single Choice ↔ Multiple Choice ↔ Sort Question',
            ruleMatrix: 'Matrix Single ↔ Matrix Multiple ↔ Matrix Statistics ↔ Matrix Blank',
            notSetTitle: 'Untitled'
        },
        changeTypeDialog: {
            title: 'Change Question Type',
            currentQuestion: 'Current Question',
            currentType: 'Current Type',
            targetType: 'Target Type',
            targetPlaceholder: 'Select target question type'
        },
        selectQuestionFirst: 'Please select a question first',
        copyLogic: {
            title: 'Copy Logic',
            sourceQuestion: 'Source Question',
            sourcePlaceholder: 'Select source question',
            promptTitle: 'Copy Logic',
            promptMessage: 'Please enter source question number (e.g., Q5)',
            selectSourceTip: 'Please select a source question',
            noSource: 'Failed to get source question logic',
            sourceEmpty: 'Source question has no logic',
            fail: 'Copy logic failed',
            failWithMsg: 'Copy logic failed: {msg}',
            projectIdMissing: 'Project ID missing; cannot copy logic',
            typeMismatchConfirmTitle: 'Type Mismatch',
            typeMismatchConfirm: 'Source ({source}) is {sourceType}, target ({target}) is {targetType}. Continue to overwrite? ',
            notFoundSource: 'Source question not found: {qno}'
        },
    },
    profileView: {
        title: 'Profile',
        back: 'Back',
        edit: 'Edit',
        save: 'Save',
        cancel: 'Cancel',
        username: 'Username',
        avatar: 'Avatar',
        changeAvatar: 'Change Avatar',
        email: 'Email',
        phone: 'Phone',
        usernameRequired: 'Please enter username',
        usernameLength: 'Length must be between 3 and 20 characters',
        emailRequired: 'Please enter email address',
        emailFormat: 'Please enter a valid email address',
        phoneRequired: 'Please enter phone number',
        phoneFormat: 'Please enter a valid phone number',
        saveSuccess: 'Saved successfully',
        saveFail: 'Save failed',
        avatarTypeError: 'Only JPG format is allowed for avatar!',
        avatarSizeError: 'Avatar size cannot exceed 2MB!',
    },
    notFound: {
        title: '404',
        pageNotFound: 'Page Not Found',
        searching: 'We are looking for the page you want...',
        backHome: 'Back to Home',
    },
    iconSelect: {
        placeholder: 'Please enter the icon name',
    },
    tinymce: {
        placeholder: 'Please enter the text here',
    },
    favoritesCenter: {
        title: 'Favorites Center',
        subtitle: 'Manage your question and script favorites',
        add: 'Add Favorite',
        name: 'Name',
        type: 'Type',
        content: 'Content',
        scope: 'Scope',
        personal: 'Personal',
        public: 'Public',
        question: 'Question',
        script: 'Script',
        scriptType: 'Script Type',
        scriptTypeBefore: 'Before',
        scriptTypeMiddle: 'Middle',
        scriptTypeAfter: 'After',
        tag: 'Tag',
        remark: 'Remark',
        uploader: 'Uploader',
        createTime: 'Created At',
        actions: 'Actions',
        edit: 'Edit',
        delete: 'Delete',
        collect: 'Collect',
        approve: 'Approve',
        reject: 'Reject',
        filterName: 'Favorite Name',
        filterType: 'Type',
        filterScope: 'Scope',
        filterSearch: 'Search',
        dialogAdd: 'Add Favorite',
        dialogEdit: 'Edit Favorite',
        dialogUneditable: 'Question favorites cannot be edited',
        dialogCancel: 'Cancel',
        dialogConfirm: 'Confirm',
        deleteConfirm: 'Are you sure to delete this favorite?',
        deleteSuccess: 'Deleted successfully',
        deleteFail: 'Delete failed',
        addSuccess: 'Added successfully',
        editSuccess: 'Edited successfully',
        collectConfirm: 'Are you sure to collect this {type} to personal favorites?',
        collectSuccess: '{type} collected successfully',
        collectFail: 'Collect failed: {msg}',
        personalCollect: 'Personal Favorite',
        publicCollect: 'Public Favorite',
        pendingAudit: 'Pending Audit',
        approvedPublic: 'Public (Approved)',
        auditEdit: 'Audit Edit',
        auditSuccess: 'Audit successful',
        rejectConfirm: 'Are you sure to reject this public conversion request?',
        noEditTip: 'Question favorites cannot be edited',
        page: 'Page',
        pageSize: 'Page Size',
    },
    brands: {
        common: {
            all: 'All',
            id: 'ID',
            actions: 'Actions',
            search: 'Search',
            reset: 'Reset',
            refresh: 'Refresh',
            edit: 'Edit',
            delete: 'Delete',
            save: 'Save',
            cancel: 'Cancel',
            tip: 'Tip',
            saveFail: 'Save failed',
            deleteFail: 'Delete failed'
        },
        category: {
            title: 'Brand Categories',
            create: 'Add Category',
            listTitle: 'Category List',
            onlyTop: 'Top-level only',
            searchPlaceholder: 'Search category name',
            parentPlaceholder: 'Level 1',
            childPlaceholder: 'Level 2',
            level1: 'Level 1',
            level2: 'Level 2',
            columns: {
                name: 'Category Name',
                level: 'Level',
                parent: 'Parent'
            },
            createTitle: 'Add Category',
            editTitle: 'Edit Category',
            deleteConfirmMessage: 'Are you sure to delete this category?',
            form: {
                name: 'Category Name',
                level: 'Level',
                parent: 'Parent',
                levelPlaceholder: 'Please select level',
                parentPlaceholder: 'Level 2 requires a parent category',
                nameRequired: 'Please enter category name',
                levelRequired: 'Please select level',
                parentRequired: 'Level 2 requires a parent category'
            }
        }
    },
    selectQuestionFirst: 'Please select a question first',
    pricing: {
        login: 'Login',
        register: 'Register',
        heroTitle: 'Choose the Right Plan',
        heroSubtitle: 'Flexible pricing plans to meet the needs of businesses of all sizes',
        year: 'year',
        yearFrom: 'year and up',
        recommended: 'Recommended',
        buyNow: 'Buy Now',
        contactSales: 'Contact Sales',
        freeTrial: 'Free Trial',
        contactMsg: 'Please contact us via service hotline or online support for more details',
        heroEyebrow: 'YiSurvey Pricing',
        heroLine1: 'Choose by',
        heroLine2: 'research capacity.',
        heroLine3: 'Built for your team.',
        heroDescription: 'Turn budget into clear questionnaire capacity, response volume, analytical depth, and deployment options. Standard, Premium, and Flagship plans support daily research, dedicated insight teams, and enterprise deployment.',
        purchasePathLabel: 'Purchase path',
        routeCapabilities: 'Capabilities',
        routePlans: 'Pricing plans',
        routeSales: 'Contact sales',
        viewPlans: 'View plans',
        proposalIndex: 'Proposal Index',
        proposal: {
            standard: '100K responses / 5 sub-accounts',
            premium: '200K responses / AI insights',
            flagship: '300K responses / On-premise',
            flagshipPrice: 'From ¥45,368'
        },
        axis: {
            design: 'Design',
            send: 'Send',
            collect: 'Collect',
            analyze: 'Analyze',
            integrate: 'Integrate'
        },
        capacityTitle: 'Questionnaire creation / Sample collection / Data delivery',
        capacityDescription: 'Every plan supports a complete research workflow, with greater scale, automation, and delivery depth at each level.',
        plansEyebrow: 'Plans',
        plansTitle: 'Three plans, from growing teams to on-premise deployment.',
        comparisonRailTitle: 'Detailed feature comparison',
        answerQuota: 'Response quota',
        administrators: 'Administrators',
        deliveryFocus: 'Delivery focus',
        matrixEyebrow: 'Capability Matrix',
        comparisonDescription: 'Compare design, sending, collection, analysis, and system integration so procurement, business, and technical teams can decide together.',
        helpEyebrow: 'Need Help?',
        ctaDescription: 'Register now to try Enterprise Standard features for free. Contact sales for on-premise deployment, invoicing, or contract terms.',
        footerCopyright: 'YiSurvey. All rights reserved.',
        backHome: 'Back to home',
        emailSubject: 'YiSurvey pricing inquiry',
        emailBody: 'Hello, I would like to learn more about YiSurvey pricing plans. Please contact me.',
        standard: {
            name: 'Enterprise Standard',
            desc: 'For Small Businesses',
            kicker: 'Standard Capacity',
            answerCap: '100K',
            adminCap: '5 sub-accounts',
            serviceCap: 'Core service',
            f1: '100 surveys/day',
            f2: '100K responses',
            f3: '5 sub-admin accounts',
            f4: 'Service consultant + Basic exam',
            f5: 'Basic data analysis'
        },
        premium: {
            name: 'Enterprise Premium',
            desc: 'For Medium & Large Businesses',
            kicker: 'Recommended',
            answerCap: '200K',
            adminCap: '5 sub-accounts',
            serviceCap: 'AI insights',
            f1: 'Unlimited survey creation',
            f2: '200K responses (expandable)',
            f3: '5 sub-admin accounts',
            f4: 'Branding + 360° assessment',
            f5: 'Full exam + AI insights'
        },
        flagship: {
            name: 'Enterprise Flagship',
            desc: 'For Large Enterprises/Gov/Universities',
            kicker: 'Enterprise Deployment',
            answerCap: '300K',
            adminCap: '10 sub-accounts',
            serviceCap: 'On-premise',
            f1: 'Unlimited survey creation',
            f2: '300K responses (expandable)',
            f3: '10 sub-admin accounts',
            f4: 'Gold consultant + On-premise',
            f5: 'CSS/JS + Multi-language'
        },
        comparisonTitle: 'Detailed Feature Comparison',
        colFeature: 'Feature',
        ctaTitle: 'Not sure which plan to choose?',
        ctaSubtitle: 'Register now for a free trial of Enterprise Standard features',
        group: {
            design: 'Survey Design',
            send: 'Send Survey',
            collection: 'Collect Responses',
            analysis: 'Data Analysis',
            satisfaction: 'Solutions - Satisfaction Assessment',
            systemIntegration: 'System Integration'
        },
        row: {
            surveyLimit: 'Surveys Created/Published',
            validPeriod: 'Survey Validity Period',
            questionTypes: 'Question Types',
            logicRelation: 'Logic Relations',
            formula: 'Calculation Formula',
            quota: 'Quota Setting',
            passwordProtect: 'Password Protection',
            conditionalAction: 'Conditional Post-submit Actions',
            duplicateCheck: 'Duplicate Submission Check',
            breakpointResume: 'Breakpoint Resume',
            externalQuery: 'External Query',
            modifyAnswer: 'Respondent Edit Answer',
            pageTimer: 'Page Timer Control',
            webEmbed: 'Website Embed',
            emailSend: 'Email Sending',
            transferSurvey: 'Transfer Survey',
            customSource: 'Custom Source',
            customUrlParam: 'Custom URL Parameters',
            maxAnswers: 'Max Responses per Survey',
            fileSpace: 'File Upload Storage',
            autoFilterInvalid: 'Auto-filter Invalid Responses',
            downloadReport: 'Download Report (Word/Excel/SPSS)',
            exportWord: 'Export Answers to Word/PDF',
            customWordExport: 'Custom Word Template Export',
            batchDownload: 'Batch Attachment Download',
            shareData: 'Share Detailed Data',
            sampleService: 'Sample Service (Paid)',
            crossAnalysis: 'Cross-tab Analysis',
            sourceAnalysis: 'Response Source Analysis',
            completionRate: 'Completion Rate Analysis',
            npsScore: 'NPS Score',
            npsTrend: 'NPS Trend',
            swotAnalysis: 'SWOT Dimension Analysis',
            industryCompare: 'Industry Comparison',
            multiLevelReport: 'Multi-level Report',
            lowScoreAlert: 'Low Score Alert',
            quantitativeAnalysis: 'Quantitative Analysis',
            regionTimeCompare: 'Region/Timeline Comparison',
            factorCompare: 'Impact Factor Comparison',
            dedicatedCloudServer: 'Dedicated Tenant Cloud Server',
            privateCloudServer: 'Private Cloud Server'
        },
        val: {
            surveyLimitStd: 'Unlimited total (max 100/day)',
            unlimited: 'Unlimited',
            partialTypes: 'Some advanced types not supported',
            logicRef: 'Skip/Association (question, option) reference',
            formulaOne: 'Only one formula supported',
            quota50k: 'Quota rules stop after 50,000 responses. Max 50 active rules per survey',
            pwd50k: '50,000',
            pwd500k: '500,000',
            resumeLocal: 'Local only',
            resumeNetwork: 'Local + Network breakpoint resume',
            query5k: 'Data 5,000',
            query20w: 'Data 200,000',
            param1: 'One parameter',
            paramMulti: 'Multi-parameter with encryption',
            email60: 'Max 60 emails/hour',
            email300: 'Max 300 emails/hour',
            source100: 'Max 100',
            source30k: 'Max 30,000',
            answers10w: '100,000',
            answers20w: '200,000',
            space24g: '24G/year | 2G/month',
            space120g: '120G/year | 15G/month',
            export2000: 'Up to 2,000',
            export2w: 'Up to 20,000',
            export10w: 'Up to 100,000',
            cross4: '4 conditions',
            cross10: 'Up to 10 conditions',
            completionNote: 'Survey created within last 6 months, at least 1 visit in last 3 months',
            space240g: '240G/year | 20G/month',
            tenThousand: '0K',
            customPaid: 'Customizable, additional fee'
        }
    },
    request: {
        kickedOut: 'Your account was signed in elsewhere, so this session has been signed out. If this was not you, please change your password immediately.',
        badRequest: 'Invalid request parameters. Please check your input.',
        forbidden: 'You do not have permission to perform this action',
        notFound: 'The requested content does not exist or has been deleted',
        timeout: 'Request timed out. Please check your network and try again.',
        payloadTooLarge: 'The upload is too large. Please compress it and try again.',
        tooManyRequests: 'Too many requests. Please try again later.',
        serverError: 'The server failed to process the request. Please try again later.',
        serviceUnavailable: 'The service is temporarily unavailable. Please try again later.',
        failedWithStatus: 'Request failed ({status}). Please try again later.',
        networkError: 'Network error. Please check your connection and try again.'
    }
}
